export default {
  OssUpload: '/oss/ali/upload', // 文件上传
  OssAttach: '/base/oss/attach/biz', // 文件信息获取
  NationTree: '/base/nationRegion/tree', // 全国省市区
  OssBatchAttach: '/base/attach/biz/list', // 批量查询附件
  attachBizList: '/base/attach/biz/list', // 批量查询附件列表 attachIds
  attachList: '/base/attach/list', // 查询文件列表attachIds
  OssDownload: '/base/oss/download', // {attachmentId} 下载文件
  AppCsVersion: '/base/appVersion/csApp/check', // app版本信息
  AppAsVersion: '/base/appVersion/asApp/check', // app版本信息
  // 用户登录
  emailUuid: '/base/email/uuid', // [GET] 通过Id获取邮箱信息 {uuid}
  loginMenu: '/base/basic/loginUser/menus', // 登录注册菜单
  ossUpload: '/base/oss/ali/policy', // oss上传凭证
  BindUser: '/base/bindingUser', // 绑定用户
  NcConfig: '/base/config', // 阿里滑块验证配置
  Login: '/base/login/pwd', // 账号密码登录
  LoginUser: '/base/user/getUserByLogin', // 获取登录账号信息
  WechatLogin: '/base/login/weChat', // 微信扫码登录[POST]{/code}
  TokenRefresh: '/base/token/refresh', // 刷新token
  UpdatePwd: '/base/userInfo/updatePwd', // 修改密码（个人中心）
  ResetPwd: '/base/user/resetPwd', // 重置密码
  ThirdPartyBind: '/base/userInfo/thirdParty/binding', // 第三方绑定
  ThirdPartyUnbind: '/base/userInfo/thirdParty/unbind', // 第三方解绑{/provider}
  ThirdPartyList: '/base/userInfo/thirdParty/list', // 第三方绑定列表
  PwdByEmail: '/base/email/updatePwd', // 邮箱找回密码
  Logout: '/base/logout', // 退出登录
  UserInfo: '/base/userInfo/update', // 修改用户信息
  UserEmail: '/base/userInfo/updateEmail', // 修改绑定邮箱
  MsgSetList: '/base/msg/settingList', // 消息设置列表
  MsgSetup: '/base/msg/setup', // 消息设置
  // App版本
  AppVersionAdd: '/base/appVersion/add',
  AppVersionUpdate: '/base/appVersion/update',
  AppVersionDelete: '/base/appVersion/delete',
  AppVersionPage: '/base/appVersion/page',
  AppVersionDefault: '/base/appVersion/setDefault',

  // 用户管理
  User: '/base/user', // [GET]获取用户信息{/userId}
  UserAdd: '/base/user/add', // 用户[post]创建、[GET]获取用户信息{/userId}、[PUT]修改{/userId}
  UserUpdate: '/base/user/update', // 用户[post]创建、[GET]获取用户信息{/userId}、[PUT]修改{/userId}
  UserState: '/base/user/updateState', // 批量更改用户状态
  UserPage: '/base/user/page', // 用户分页查询
  UserSendEmail: '/base/user/sendEmail', // 发送邮箱重置密码
  // 组织管理
  // Organ: '/base/organ', // 组织[POST]新增、[GET]获取信息{/organId}、[PUT]更新{/organId}、[DELETE]删除{/organId}
  // OrganTree: '/base/organ/tree', // 组织树获取{/countType}
  // OrganUserOrgan: '/base/organ/user', // 获取用户顶级组织信息
  // OrganUser: '/base/organUser/organ/user', // 组织的用户[POST]新增、[DELETE]删除
  // OrganUserPage: '/base/organUser/page/user', // 组织的用户分页查询

  // 组织机构管理
  Organ: '/base/organ', // 组织详情
  OrganAdd: '/base/organ/add', // 组织新增
  OrganUpdate: '/base/organ/update', // 组织修改
  OrganDelete: '/base/organ/delete', // 组织删除
  OrganDepartmentTree: '/base/organ/department/tree', // 组织部门树
  OrganPage: '/base/organ/page', // 组织分页
  OrganTree: '/base/organ/tree', // 组织树
  OrganHqList: '/base/organ/hqList', // 设备转移组织列表
  OrganUserDetail: '/base/organ/user', // 用户组织详情（默认当前用户）
  OrganTypeSelect: '/base/organ/type/select', // 组织类型下拉
  OrganAdmin: '/base/admin', // 组织管理员信息
  OrganAllRoot: '/base/organ/inventoryParty/list', // 获取顶级组织列表（下拉用）
  organChildrenBizPage: '/base/organ/user/childrenBiz/page', // 下级组织部门分页
  OrganAutoBindByUser: '/base/organ/user/autoBind/page', // 用户已自定关联的组织部门
  OrganUnbindbyUser: '/base/user/biz/unbind', // 解除用户组织绑定

  organDeviceBindAutoAdd: '/dms/deviceBindAutomatic/batchSave', // 批量新增设备自动绑定关系
  organDeviceBindAutoDel: '/dms/deviceBindAutomatic/batch/delete', // 批量删除设备自动绑定关系
  DeviceBindAutoDevicePage: '/dms/deviceBindAutomatic/device/page', // 获取用户自动绑定的设备列表(含子公司)

  OrganStockTarget: '/base/organ/targetOrg', // 获取库存方组织列表
  OrganStockInventory: '/base/organ/open/inventoryParty/list', // 设备库存方列表
  OrganReturn: '/base/organ/returnOrg', // 设备更换组织列表
  OrganOpenAllList: '/base/organ/open/allList', // 对外-获取当前组织的所有下级组织
  OrganRelationLargeCustomerList: '/base/organ/relation/largeCustomerList', // 集团客户列表
  OrganRelationLargeCustomerCustomerList: '/base/organ/relation/largeCustomer/customerList', // 集团客户下已/未关联的租赁方
  OrganRelationDelete: '/base/organ/relation/delete', // [POST] {orgRelationId} 删除关联关系【集团客户与租赁方解绑】
  OrganRelationLargeCustomerCustomerSave: '/base/organ/relation/largeCustomer/customer/save', // 集团客户关联租赁方【集团客户与租赁方关联】

  // Organs: '/base/organ', // 组织[POST]创建、[GET]详情{/organId}、[PUT]更新{/organId}、[DELETE]删除{/organId}
  // OrgansPage: '/base/organ/page', // 组织分页列表
  // OrgansTree: '/base/organ/tree', // 组织树
  // OrgansCurrent: '/base/organ/user', // 当前用户组织

  // 部门管理
  DepartmentTree: '/base/organ/department/tree', // 组织部门树
  DepartmentCount: '/base/biz/child/user/count', // 组织人数数量统计
  Department: '/base/department', // 查看部门
  DepartmentAdd: '/base/department/add', // 添加部门
  DepartmentDelete: '/base/department/delete', // 删除部门
  DepartmentUpdate: '/base/department/update', // 修改部门
  DepartmentUserBind: '/base/department/user/bind', // 部门关联用户
  DepartmentUserPage: '/base/biz/user/page', // 部门或组织用户分页（已经/未关联）
  DepartmentUserUnbind: '/base/department/user/unbind', // 部门取消关联用户
  UserDepartmentBind: '/base/user/department/bind', // 用户关联部门或组织
  UserDepartmentBindList: '/base/user/department/bind/list', // 用户已关联的部门列表
  UserDepartmentUnbind: '/base/user/department/unbind', // 用户取消关联部门
  UserDepartmentPage: '/base/user/department/page', // 用户部门分页

  UserOrganAdd: '/base/organUser/user/organ', // 用户组织新增(批量)
  UserOrganDel: '/base/organUser/user/organ', // 用户的组织删除(批量)
  UserOrgan: '/base/organUser/organs', // 用户的组织列表{/userId}
  UserOrganPage: '/base/organUser/Page/organ', // 用户的组织[GET]分页查询{/userId}

  // 角色管理
  Role: '/base/role', // 获取角色信息{/roleId}
  RoleAdd: '/base/role/add', // 新增角色
  RoleDelete: '/base/role/delete', // 删除角色
  RoleUpdate: '/base/role/update', // 更新角色
  RoleState: '/base/role/update/state', // 禁用或启动角色
  RoleUser: '/base/role/user/bind', // 角色关联用户[POST]新增、[DELETE]删除
  RoleApproveList: '/base/role/approve/list', // 审批人所属岗位
  UserRoleUnbind: '/base/biz/role/unbind', // 用户取消关联角色/组织
  RoleUserUnbind: '/base/role/biz/unbind', // 角色取消关联用户/组织
  RoleUserBind: '/base/role/biz/bind', // 角色关联用户/角色
  RoleUserPage: '/base/role/user/page', // 角色关联用户列表(分页)
  RoleFun: '/base/role/menuFunc/bind', // 角色功能保存
  UserRoleAll: '/base/role/list', // 获取所有角色(包含消息角色)
  UserRole: '/base/biz/role/list', // 获取登录人组织下所有角色{/userId}
  roleMsgList: '/base/role/msg/list', // 获取推送岗位列表
  UserRolePage: '/base/biz/role/page', // 用户下所以角色（分页）
  UserRoleAdd: '/base/biz/role/bind', // 用户/组织下绑定角色
  UserIsAdmin: '/base/role/isAdmin', // 当前账号是否是管理员
  RoleWorkflowList: '/base/role/workflow/list', // 岗位工作流程列表
  RoleMsgTemplateGroupTree: '/base/role/msgTemplate/group/tree', // 岗位消息模板分组树
  RoleMsgTemplateList: '/base/role/msgTemplate/list', // 岗位消息模板列表
  UserServiceRole: '/base/user/list/serviceRole', // 服务岗位下用户（asm客户下）
  UserList4Role: '/base/user/list4Role', // 岗位下的用户列表
  // 菜单管理
  App: '/base/menu/tree', //  应用[GET]左侧菜单{/appId}
  AppList: '/base/menu/app', // 获取用户应用[GET]列表,
  AppMenu: '/base/app', // 获取全部应用列表（下拉选用）
  AppMenuTree: '/base/menu/fun/tree', // 获取菜单功能树{/appId}
  AppSysMenu: '/base/menu/sysMenu', // 获取系统菜单（不在侧边栏的菜单）
  // 菜单[POST]新增、[POST]修改{/menuId}、 [DELETE]删除{/menuId}
  MenuAdd: '/base/basic/menu/add', // 菜单[POST]新增、
  MenuUpdate: '/base/basic/menu/update', // 菜单修改{/menuId}
  MenuDelete: '/base/basic/menu/delete', // 菜单删除{/menuId}
  MenuState: '/base/basic/menu/updateState', // 菜单禁用启用
  menuFunc: '/base/role/menuFunc/list', // 角色已关联的菜单功能列表
  MenuFuncAs: '/base/basic/menu/associate', // 菜单功能关联
  MenuFuncDisAs: '/base/basic/menu/disassociate', // 菜单功能取消关联
  MenuAsFunc: '/base/basic/menu/menuFuncList', // 菜单已关联的功能列表{/menuId}
  MenuDisAsFunc: '/base/basic/menu/funcTree', // 菜单未关联的功能列表{/appId}
  MenuMove: '/base/basic/menu/move', // 菜单移动
  MenuTree: '/base/basic/menu/tree', // 菜单树{/appId}, 可过滤
  MenuItem: '/base/menu/loadRes', // 获取路由信息（菜单项）
  // 模块功能管理
  FuncAdd: '/base/basic/func/add', // 功能点新增
  FuncUpdate: '/base/basic/func/update', // 功能点修改
  FuncDelete: '/base/basic/func/delete', // 功能点删除{funcId}
  FuncTree: '/base/basic/func/tree', // 功能树{appId}
  FuncView: '/base/menu/funView', // 菜单下的功能点（页面按钮翻译和权限控制）
  // 多语言配置管理
  LanguageLogin: '/base/language/common', // 多语言配置(登录页免登录)
  LanguageExport: '/base/language/export', // 多语言配置数据导出
  LanguageImport: '/base/language/import', // 多语言配置数据导入
  LanguageView: '/base/language/menu/view', // 资源页面多语言配置获取
  LanguageSyncView: '/base/basic/lang/menu/batch', // 页面多语言配置同步
  LanguageSyncComp: '/base/basic/lang/sys/batch', // 组件多语言配置同步
  LanguageSyncCompApp: '/base/basic/lang/sys/batchForApp', // 组件多语言配置同步(应用下)
  LanguagePage: '/base/language/page', // 多语言配置分页列表
  LanguageTree: '/base/language/keyGroup/tree', // 多语言配置树形列表
  LanguagePlatform: '/base/language/list', // [GET]管理系统全局多语言
  LanguagePlatformListForApp: '/base/language/listForApp', // [GET]应用平台多语言
  LanguageSetup: '/base/language/setup', // 多语言配置设置
  // 多语言管理页面
  LanguageKeyGroupTree: '/base/basic/keyGroup/tree', // [获取分组树的下拉
  LanguageKeyGroupAdd: '/base/basic/keyGroup/add', // 分组新增
  LanguageKeyGroupUpdate: '/base/basic/keyGroup/update', // 分组修改
  LanguageKeyGroupDelete: '/base/basic/keyGroup/delete', // 分组删除{/langKeyId}
  // 多语言Key管理
  LanguageKeyLangAdd: '/base/basic/lang/add', // 多语言Key新增
  LanguageKeyLangUpdate: '/base/basic/lang/update', // 多语言Key修改
  LanguageKeyLangDelete: '/base/basic/lang/delete', // 多语言Key删除{/langKeyId}
  // 字典管理
  DictionaryAdd: '/base/dict/add', // 字典项新增
  DictionaryDelete: '/base/dict/delete', // 字典删除
  DictionaryUpdate: '/base/dict/update', // 字典项修改
  DictionaryCode: '/base/dict/listForGroupCodes', // 字典项下拉选查询
  DictionaryLangLogin: '/base/dict/common/lang', // 语种下拉选(登录页免登录)
  DictionaryPage: '/base/dict/page', // 字典项分页列表
  DictionaryTree: '/base/dict/tree', // 字典项树形列表
  // 字典分组
  DictGroupTree: '/base/dictGroup/tree', // 字典分组树形分页
  DictGroupAdd: '/base/dictGroup/add', // 字典分组新增
  DictGroupUpdate: '/base/dictGroup/update', // 字典分组更新
  DictGroupDelete: '/base/dictGroup/delete', // 字典分组删除
  DictGroupSelectTree: '/base/basic/dicGroup/selectTree', // 字典分组树形下拉列表
  // 自定义表格列
  TableColumnAdd: '/base/basic/tableColumn/add', // 表格列新增
  TableColumnUpdate: '/base/basic/tableColumn/update', // 表格列更新
  TableColUpdate: '/base/basic/tableColumn/updateWidth', // 表格列拖拽更新
  TableColumnPage: '/base/basic/tableColumn/page', // 表格列分页列表
  TableColumnDelete: '/base/basic/tableColumn/delete', // 表格列删除{/columnId}
  TableColumnGet: '/base/tableColumn/list', // 页面获取表格列
  TableColumSet: '/base/tableColumn/setup', // 页面表格列设置
  // 消息规则配置
  PushRulePage: '/base/pushRule/page', // 消息规则配置分页
  PushRuleInfo: '/base/pushRule/info', // 消息规则配置信息
  PushRuleDelete: '/base/pushRule/delete', // 消息规则配置删除
  PushRuleSave: '/base/pushRule/save', // 消息规则配置新增编辑保存
  PushRuleConfig: '/base/pushConf/select', // 消息推送配置-下拉
  // 消息推搡模板配置
  MsgTemplateGroupAdd: '/base/msgTemplate/group/add', // 分组模板树
  MsgTemplateGroupUpdate: '/base/msgTemplate/group/update', // 分组模板树
  MsgTemplateGroupDelete: '/base/msgTemplate/group/delete', // 分组模板树
  MsgTemplateGroupTree: '/base/msgTemplate/group/tree', // [GET]获取模板分组树 {groupLevel=1}获取所有目录  {groupLevel=2}获取所有叶子
  MsgTemplateSave: '/base/msgTemplate/saveTemplate', // 保存模板内容
  MsgTemplateGet: '/base/msgTemplate/getTemplate', // 获取模板内容
  // 消息推送配置
  PushConfPage: '/base/pushConf/page', // 消息推送配置分页 [GET]获取分页数据
  PushConfInfo: '/base/pushConf/info/', // 消息推送配置信息  [GET]{triggerCode}获取基本信息
  PushConfDelete: 'base/pushConf/delete/', // 消息推送配置删除 [DELETE]{triggerCode}删除基本信息
  PushConfSave: '/base/pushConf/save', // 消息推送配置编辑保存 [POST]新增
  // PushConfConfig: '/base/pushConf/select', // 消息推送配置-下拉 [GET]

  // 消息中心
  msgRecordPage: '/base/msgRecord/page', // [GET] 消息中心
  msgRecordInfo: '/base/msgRecord/info', // [GET] {messageId} 消息中心详情
  msgRecordRead: '/base/msgRecord/read', // [POST] 消息已读
  msgRecordReadAll: '/base/msgRecord/read/all', // [POST] 全部已读
  msgRecordDelete: '/base/msgRecord/delete', // 消息中心-删除
  msgRecordTotalInit: '/base/msgRecord/totalInit', // [GET] 消息统计数
  msgRecordClassList: '/base/msgRecord/msgClass/list', // 消息分类列表

  // 日志
  LoginLogPage: 'logger/loginLog/page', // [POST] 登录日志
  loginLogExport: 'logger/loginLog/export', // [POST] 登录日志导出
  bizLogPage: 'logger/bizLog/page', // [POST] 业务日志分页
  logPage: 'logger/log/page', // [POST] 接口日志分页
  LogAllInfo: '/logger/log/allInfo', // 日志详情-全部 [GET]获取日志详情
  LogInfo: 'logger/log/info', // 日志详情 [GET]获取日志详情

  // u8日志
  logsU8RecordsPage: '/logger/logs/u8/records/page', // [POST] 列表
  logsU8Info: '/logger/logs/u8/info', // {id} [GET] 详情
  logsU8Repush: '/logger/logs/u8/repush', // [POST] 重推
  logsU8UrlTypeList: '/logger/logs/u8/urlTypeList', // [GET] 接口类型列表

  // 通知管理
  noticePage: '/base/notice/page', // [GET] 通知管理-分页
  noticeAdd: '/base/notice/add', // [POST]新增
  noticeDelete: '/base/notice/delete', // {noticeId} [POST]删除通知管理
  noticePublish: '/base/notice/publish', // {noticeId} [POST] 通知管理-发布
  noticeDisable: '/base/notice/disable', // {noticeId} [POST]通知管理-禁用
  noticeEdit: '/base/notice/edit', // [POST]通知管理-修改通知
  noticeInfo: '/base/notice/info', // [GET]  {noticeId} 通知管理详情
  noticeReaded: '/base/notice/readed', // [POST] {noticeId} 通知管理-已读
  noticeNoticeIndex: '/base/notice/noticeIndex', // [GET]  首页-拉取未读的公告列表
  noticePageBySelf: '/base/notice/pageBySelf', // [GET]  通知管理-个人收到的通知列表 (暂时还没用)
  // 应用管理
  basicApplicationPage: '/base/basic/application/page', // [GET]应用分页列表
  basicApplicationAdd: '/base/basic/application/add', // [POST]新增应用
  basicApplicationDelete: '/base/basic/application/delete', // [DELETE] {appId} 删除应用
  basicApplicationUpdate: '/base/basic/application/update', // [PUT]{appId}修改应用
  basicApplicationPlatformList: '/base/basic/application/platformList', // 应用分页列表
  // 指标管理
  quotaPage: '/base/quota/page', // [GET] 指标管理-分页
  quotaInfo: '/base/quota/info', // [GET]指标管理详情 {id}
  quotaSave: '/base/quota/save', // [POST]指标管理 新增/编辑
  quotaDelete: '/base/quota/delete', // [DELETE] {id} 指标管理 删除
  // 站点管理
  websiteAdd: '/base/website/add', // [POST]站点-新增
  websiteCommon: '/base/website/common', // [GET]登录页站点下拉选(免token拦截验证)
  websiteDelete: '/base/website/delete', // [POST]{websiteId}站点-删除
  websitePage: '/base/website/page', // [GET]站点列表
  websiteSelectList: '/base/website/selectList', // [GET]站点-下拉选
  websiteUpdate: '/base/website/update', // [POST]站点-编辑
  // 工厂发货HQ的交付地管理
  factoryDeliveryPlaceSelectList: '/base/factoryDeliveryPlace/selectList', // 国家站点下拉选
  // 指标查询条件管理
  quotaConditionGetPageList: '/base/quotaCondition/getPageList', // [GET] 查询条件-分页
  quotaConditionInfo: '/base/quotaCondition/info', // [GET] 查询条件详情  {id}
  quotaConditionSave: '/base/quotaCondition/save', // [POST] 新增/编辑查询条件
  quotaConditionDelete: '/base/quotaCondition/delete', // [DELETE] 删除查询条件 {id}

  //  产品管理
  Product: '/dms/product', // 产品
  ProductDel: '/dms/product/delete', // 产品删除
  ProductCount: '/dms/product/count', // 产品设备数量统计
  ProductStateCount: '/dms/product/count/state', // 有效无效产品统计
  ProductPage: '/dms/product/page', // 产品分页列表
  ProductExport: '/dms/product/export', // 导出产品
  ProductModelList: '/dms/product/validList', // 有效产品型号列表
  ProductInfo: '/dms/product/info', // 产品型号获取产品详情
  ProductCycle: '/dms/product/upkeepCycle/page', // 产品保养周期分页
  ProductInfoAdd: '/dms/product/info/add', // 新增产品基本信息
  ProductInfoUpdate: '/dms/product/info/update', // 更新产品基本信息
  ProductInfoDetail: '/dms/product/info/detail', // 获取产品基本信息
  ProductParamDetail: '/dms/product/param/detail', // 获取产品参数信息
  ProductParamSave: '/dms/product/param/save', // 保存产品参数
  componentList: '/dms/component/list', // [GET]获取部件分类列表 /productStructure/list/{productSn}
  ProductStructureSaveType: '/dms/productStructure/save/type', // 部件分类保存/新增
  ProductStructureSave: '/dms/productStructure/save', // 部件保存/新增
  ProductStructureDelete: '/dms/productStructure/delete', // /productStructure/delete/{id} 删除部件
  ProductStructureCopyListProduct: '/dms/productStructure/copy/list/product', // 复制部件-产品列表
  ProductStructureCopyPageStructure: '/dms/productStructure/copy/page/structure', // 复制部件-组件分页
  ProductStructureCopyStructureSave: '/dms/productStructure/copy/structure/save', // /productStructure/copy/structure/save/{productSn} 复制部件-批量保存
  ProductStructureDbList: '/dms/productStructure/db/list',
  ProductStructureExport: '/dms/productStructure/export', // [GET] 导出部件
  ProductStructureIconList: '/dms/productStructure/iconList', // [GET] 部件图标附件id集合
  ProductStructureDbSave: '/dms/productStructure/db/save',
  ProductStructureTopicSelect: '/dms/productStructure/topic/select', // topic关联物模型-选择部件
  ProductDetail: '/dms/product/detail', // 产品查看（详情）
  ProductConfigExport: '/dms/product/config/export', // [GET] 导出产品配置
  ProductForceDelete: '/dms/product/forceDelete', // [POST] {productId} 强制删除产品
  ProductActiva: 'dms/dmsDeviceExtend/updateActiva', // 更新
  LisencePage: '/dms/license/page', // lisenc分页列表
  LisenceExport: '/dms/license/export', // lisence导出
  productProtocolBinding: '/dms/product/protocol/binding', // 绑定协议
  productProtocolDelete: '/dms/product/protocol/delete', // {productProtocolId}解除绑定的协议
  productProtocolList: '/dms/product/protocol/list', // 已绑定协议
  productProtocolSelectList: '/dms/product/protocol/selectList', // 可绑定协议
  productValidList: '/dms/product/validList', // 产品列表
  productComponentList: '/dms/product/component/list', // 已绑定协议下的结构树
  simDataRecordPage: '/crms/sms/orderSim/page', // 设备数据服务
  simDataRecordExport: '/crms/sms/orderSim/export', // 设备数据服务导出
  simDataSelect: '/crms/sms/goods/simService/selectList', // 数据服务选择列表(选项)
  simDataDeviceSelect: '/crms/sms/orderSim/deviceSelect', // 购买设备列表
  simDataBuyApply: '/crms/sms/orderSim/apply', // 提交数据服务购买
  simDataBuyApplyInfo: '/crms/sms/orderSim/applyInfo', // 提交数据服务审批详情
  simDataApplyForEus: '/crms/sms/orderSim/applyForEus', // [POST] 欧美购买申请提交
  productSnList: '/dms/product/snList', // 产品SN列表

  // 工厂库存
  factoryStockExport: '/dms/factoryStock/export', // [GET] 工厂列表-导出

  giveawayPreShipDetail: '/crms/rms/giveaway/preShipDetail', // 预发货明细
  giveawayPreShipDetailPage: '/crms/rms/giveaway/preShipDetail/page', // 预发货明细分页-发货页使用
  giveawayOrderGoodsCodes: '/crms/rms/giveaway/orderGoodsCodes', // 订单商品编码列表-全选发货时使用
  giveawayShip: '/crms/rms/giveaway/ship', // 预发货明细
  giveawayBalanceExport: '/crms/rms/giveaway/balance/export',
  giveawayBalancePage: '/crms/rms/giveaway/balance/page', // 配件存留
  giveawayBalanceRecordExport: '/crms/rms/giveaway/balance/record/export',
  giveawayBalanceRecordPage: '/crms/rms/giveaway/balance/record/page', // 存留使用记录

  // 产品型号管理
  productCodeAdd: '/dms/productCode/add', // 新增产品基本信息
  productCodeDelete: '/dms/productCode/delete', // {productCodeId}更新产品基本信息
  productCodeExport: '/dms/productCode/export', // 导出产品
  productCodeInfo: '/dms/productCode/info', // 产品信息获取（编辑回显用）
  productCodePage: '/dms/productCode/page', // 产品分页列表
  productCodeSelectList: '/dms/productCode/selectList', // 有效产品列表
  productCodeRuleSelectList: '/crms/rms/sharingRule/productList', // 有效产品列表（新）
  productCodeUpdate: '/dms/productCode/update', // 更新产品基本信息
  productCodeLifeList: '/dms/productCode/componentLife/list', // 型号下有使用寿命的结构列表
  productCodeParentList: '/dms/productCode/componentLife/parentList', // 型号下结构分组下拉选
  productCodeLifeSetup: '/dms/productCode/componentLife/setup', // 设置使用寿命

  // 物模型
  TslDelete: '/dms/tsl/delete', // /{tslId}删除物模型
  TslDetail: '/dms/tsl/detail', // 产品物模型详情
  TslVersion: '/dms/tsl/hisVersion', // 产品物模型历史版本列表
  TslImport: '/dms/tsl/import', // 物模型快速导入
  TslImportPage: '/dms/tsl/importPage', // 物模型快速导入可选分页列表
  TslJoinDraft: '/dms/tsl/joinDraft', // /{tslId}加入草稿
  TslJoinDraftBatch: '/dms/tsl/joinDraftBatch', // 版本加入草稿
  TslPage: '/dms/tsl/page', // 物模型分页列表
  TslPublish: '/dms/tsl/publish', // 发布物模型
  TslSave: '/dms/tsl/save', // 保存物模型
  TslSelectList: '/dms/tsl/selectList', // 产品物模型下拉选数据
  TslDataSelectList: '/dms/tsl/data/selectList', // 产品物模型数据下拉选
  TslTopicAssociatedList: '/dms/tsl/topic/associated/list', // 已关联topic的物模型列表
  TslTopicUnAssociatePage: '/dms/tsl/topic/unAssociate/page', // 未关联topic的物模型列表
  TslTopicPreAssociateList: '/dms/tsl/topic/preAssociate/list', // 预关联topic的物模型列表
  TopicTslColumnWidthSetup: '/dms/topic/tsl/columnWidth/setup', // topic物模型列宽设置
  // 固件管理
  FirmwarePage: '/dms/firmware/page', // [GET] 固件分页列表
  FirmwareList: '/dms/firmware/list', // [GET] 固件下拉列表{/firmwareType}
  FirmwareDelete: '/dms/firmware/delete', // [POST] {firmwareId}  固件删除
  FirmwareAdd: '/dms/firmware/add', // [POST] 新建固件第一步
  Firmware: '/dms/firmware', // [GET]固件查询第一步骤info
  FirmwareInfo: '/dms/firmware/info', // [GET]固件详情
  FirmwareProtocolLink: '/dms/firmware/protocol/link', // [POST] 固件关联协议
  FirmwareProtocolList: '/dms/firmware/protocol/list', // [GET] 固件关联的协议列表
  FirmwareProtocolPage: '/dms/firmware/protocol/page', // [GET] 固件协议分页
  FirmwareProtocolUnlink: '/dms/firmware/protocol/unlink', // [POST] 固件协议取消关联{id}
  FirmwareExport: '/dms/firmware/export', // [GET] 固件导出
  FirmwareUpdateState: '/dms/firmware/updateState', // [POST] {firmwareId}/{state} 固件禁用/启用

  FirmwareUpdate: '/dms/firmware/update', // [POST] 固件修改
  FirmwareUpload: '/dms/firmware/upload', // [POST] 固件包上传
  FirmwareProtocolUnlinkList: '/dms/firmware/protocol/unlink/list', // [GET]固件未关联的协议版本列表
  // 资源管理
  resourceExport: '/dms/resource/export', // [GET] 资源导出
  resourceInfo: '/dms/resource/info', // [GET] {resourceId}详情
  resourcePage: '/dms/resource/page', // [GET] 分页列表
  resourceSaveOrUpdate: '/dms/resource/saveOrUpdate', // [POST]编辑或保存
  resourceUpdateState: '/dms/resource/updateState', // [POST]{resourceId}/{state}禁用/启用/删除
  resourceSelectList: '/dms/resource/selectList', // 向下兼容版本号
  resourceSelect2List: '/dms/deviceStructure/fwVersion/selectList', // 获取版本号
  resourcePublish: '/dms/resource/publish', // 固件资源发布与取消 /{resourceId}/{isPublish}
  resourcePageForDevice: '/dms/resource/pageForDevice', // 设备/modem的固件列表
  ProductProductVersionSelect: '/dms/product/productVersion/select', // [GET]  产品版本下拉选
  // IOT资源协议管理
  resourceProtocolSelectList: '/dms/resourceProtocol/selectList', // 协议下拉列表
  resourceProtocolList: '/dms/resourceProtocol/list', // 资源管理关联的产品协议

  // 产品协议
  // Protocol: '/dms/protocol', // 产品[POST]新增、[GET]查询分页列表、[PUT]更新{/productId}
  ProtocolPage: '/dms/protocol/page', // 产品分页
  protocolInfo: '/dms/protocol/info', // [GET] {protocolCode} 协议详情
  ProtocolAdd: '/dms/protocol/add', // 产品新增
  ProtocolUpdate: '/dms/protocol/update', // 产品更新
  ProtocolDetail: '/dms/protocol/deteil', // 产品详情
  ProtocolSelectList: '/dms/protocol/selectList', // 协议列表
  // ProtocolList: '/dms/protocol/list', // 协议列表
  ProtocolGroupPage: '/dms/protocol/group/page', // 分页分组树
  ProtocolGroupAdd: '/dms/protocol/group/add', // 新增分组树
  ProtocolGroupUpdate: '/dms/protocol/group/update', // 更新分组树
  ProtocolGroupDelete: '/dms/protocol/group/delete', // 删除分组树
  ProtocolSave: '/dms/protocol/save', // 保存产品协议
  ProtocolAllList: '/dms/protocol/allList', // 查询产品所有协议
  ProtocolCancelPublish: '/dms/protocol/cancelPublish', // 撤销发布 /protocol/cancelPublish/{protocolId}
  ProtocolPublish: '/dms/protocol/publish', // 发布 /protocol/publish/{protocolId}
  ProtocolDelete: '/dms/protocol/delete', // 删除协议 /protocol/delete/{protocolId}
  // /protocol/delete/{protocolId} 删除IotProtocol对象

  // ProtocolParam: '/dms/protocol/param', // 配置参数[POST]新增、[GET]查询参数、[PUT]更新参数{/paramId}、[DELETE]删除分组{/paramId}
  ProtocolParamPage: '/dms/protocol/param/page', // 配置参数查询
  ProtocolParamAdd: '/dms/protocol/param/add', // 配置参数新增
  ProtocolParamUpdate: '/dms/protocol/param/update', // 配置参数更新
  ProtocolParamDelete: '/dms/protocol/param/delete', // 配置参数删除

  ProtocolGroupTree: '/dms/protocol/group/treeByType', // 指定类型的分组树查询（下拉选)
  ProtocolParamList: '/dms/protocol/param/list', // 指定分组下的参数列表
  ProtocolParamAllList: '/dms/protocol/param/allList', // 获取所有的参数列表
  FirmwareProtocol: 'dms/firmware/protocol', // [GET]查询参数/{protocolId}

  // 告警规则
  iotRulePage: '/dms/iotRule/page', // [GET]查询参数 规格分页
  iotRuleExport: '/dms/iotRule/export', // [GET]导出
  iotRuleInsert: '/dms/iotRule/insert', // [POST]新增规则
  iotRuleInfo: '/dms/iotRule/info', // [GET] {id} 获取规则详情
  iotRuleUpdate: '/dms/iotRule/update', // [PUT] 修改规则
  iotRuleDelete: '/dms/iotRule/delete', // {id}
  iotRuleState: '/dms/iotRule/update/state',
  iotRuleSelectHelpCondition: '/dms/iotRule/select/help/condition', // [GET] 修改规则
  ProductList: '/dms/product/list', // [GET]产品编号、型号下拉
  productStructureRuleSelect: '/dms/productStructure/rule/select', // 通过产品{productCode}去查询部件

  // IOT产品topic
  TopicPage: '/dms/topic/page', // topic分页列表
  TopicDelete: '/dms/topic/delete', // /topic/delete/{topicId} 删除产品topic
  TopicSave: '/dms/topic/save', // 保存产品topic
  TopicUpdateState: '/dms/topic/updateState', // 启用/禁用
  TopicImportPage: '/dms/topic/importPage', // topic快速导入分页列表
  TopicImport: '/dms/topic/import', // 快速导入topic
  TopicAssociateTsl: '/dms/topic/associateTsl', // 关联物模型-关联
  TopicEditAssociateTsl: '/dms/topic/editAssociateTsl', // 关联物模型-编辑
  TopicCancelAssociateTsl: '/dms/topic/cancelAssociateTsl', // 关联物模型-取消关联
  TopicList: '/dms/topic/list/productCode', // [GET]{protocolId} 通过产品编号查询topic下拉列表
  TopiclistProtocolId: '/dms/topic/list/protocolId', // [GET]{protocolId} 通过协议id查询topic下拉列表
  // TopiclistProductCode: '/dms/topic/list/productCode', // [GET]{productCode} 通过产品编号查询topic下拉列表
  TopicExport: '/dms/topic/export', // [GET] 导出topic
  TopicConfigTopicList: '/dms/topic/configTopic/list', // [GET] 配置服务topic

  TopicPublishSelectList: '/dms/topic/publish/selectList', // [GET]通过tcpVersion查询topic下拉列表
  protocolPublishTcpVersionSelectList: '/dms/protocol/publish/tcpVersion/selectList', // [GET]协议发布版本下拉
  TopicPublishList: '/dms/topic/publish/list', // [GET] topic发布记录-列表

  TopicDetail: '/dms/topic/detail', // [GET] 查看topic详情
  TopicDbList: '/dms/topic/dbList', // topic数据关系列表
  TopicSelectTopic: '/dms/topic/selectTopic', // [GET] 衍生协议-topic选择列表
  TopicSetTopic: '/dms/topic/setTopic', // [POST] 衍生协议-设置topic

  // TopicPublishTopic: '/iot/topic/publish', // /topic/publish/{topicId}/{version}   发布topic版本
  // TopicPublishTopicCode: '/iot/topic/publish', // /topic/publish/topicCode    发布topic版本
  // TopicVersionDelete: '/iot/topic/version/delete', // /topic/version/delete/{id}   删除版本
  // TopicVersionDisable: '/iot/topic/version/disable', // /topic/version/disable/{id}   禁用版本
  // TopicVersionEnable: '/iot/topic/version/enable', // /topic/version/enable/{id}    启用版本
  // TopicVersionInfoById: '/iot/topic/version/infoById', // /topic/version/infoById/{id}   版本信息
  // TopicVersionRecord: '/iot/topic/version/record', // /topic/version/record/{topicId}   历史版本记录
  tslRuleSelectStructure: '/dms/tsl/rule/select/structure', // 通过部件查{componentCode}?tslType&productSn productSn(必填)
  iotTslDataRuleSelect: '/dms/iotTslData/rule/select', // 根据 /{tslId}查询物模型下的参数
  tslRuleSelectTslData: '/dms/tsl/rule/select/tslData', // 根据 /{tslId}查询物模型下的参数
  pushConfRuleSelect: '/base/pushConf/rule/select', // 消息代号下拉
  // basicFaultRuleList: '/dms/basicFault/rule/list', // 故障代号下拉

  dmsEventCodeList: '/dms/event/codeList', // 消息代号下拉

  // 设备地图
  MyDeviceCount: '/dms/map/myDevice/count', // 数量统计
  MyDeviceModelList: '/dms/map/myDevice/productCode/list', // 型号列表
  MyDeviceList: '/dms/map/myDevice/list', // 设备列表
  MyDevicePage: '/dms/map/myDevice/page', // 设备分页列表
  MyDeviceExport: '/dms/myDevice/export', // (实时信息)我的设备-导出
  MyDeviceBizPage: '/dms/myDevice/biz/page', // (业务信息)我的设备-分页列表
  MyDeviceBizExport: '/dms/myDevice/biz/export', // (实时信息)我的设备-导出
  MyDeviceBizInfo: '/dms/stock/bizInfo', // 编辑业务信息详情
  MyDeviceBizUpdate: '/dms/stock/bizInfo/update', // 编辑业务信息修改

  // 新机入库
  InStock: '/dms/stockIn/insert', // 新机入库
  InStockCheck: '/dms/stockIn/excel', // 入库检测
  InStockBatchIn: '/dms/stockIn/excel/save', // 批量入库
  InStockCheckPage: '/dms/stockIn/excel/checkPage', // 入库检测分页
  InStockTpl: '/dms/stockIn/downloadTemplate', // 导入模板下载
  InStockFailExport: '/dms/stockIn/excel/exportFailData', // 检测错误导出
  InStockPage: '/dms/stockIn/page', // 库存设备列表
  InStockExport: '/dms//stockIn/export', // 新机入库导出

  // 事件管理(页面已经改为基础故障配置  有可能冗余)
  DmsEventPage: '/dms/dmsEventDm/page', // 设备事件分页
  DmsEventAdd: '/dms/dmsEventDm/insert', // 设备事件新增
  DmsEventSelect: '/dms/dmsEventDm/select', // 查询事件
  DmsEventDelete: '/dms/dmsEventDm/delete', // 删除事件
  DmsEventUpdate: '/dms/dmsEventDm/update', // 更新事件

  // 基础故障配置
  basicFaultPage: '/dms/basicFault/page', // 基础故障配置分页查询
  basicFaultSave: '/dms/basicFault/save', // 新增修改基础故障
  basicFaultInfo: '/dms/basicFault/info', // 故障信息详情/{id}
  basicFaultDelete: '/dms/basicFault/delete', // 删除基础故障/{id}

  // 设备管理
  DeviceWaitPage: '/dms/device/wait/page', // 未分配设备列表
  // DeviceOrganTree: '/dms/device/organ/tree', // 关联设备组织树
  DevicePage: '/dms/myDevice/page', // 我的设备列表
  DeviceCount: '/dms/device/my/count', // 设备统计（饼图）
  DeviceBind: '/dms/biz/device/bind', // 单个部门或用户绑定多个设备
  DeviceBindUser: '/dms/device/wait/biz/bind', // 多个设备关联多个部门或用户
  DeviceAutoUser: '/dms/device/automatic/update', // 更改用户关联规则
  BizDeviceUnbind: '/dms/biz/device/unbind', // 批量取消关联设备
  BizDevicePage: '/dms/biz/device/page', // 组织或用户已、未关联的设备分页列表
  DeviceOrganUser: '/dms/device/user/organ', // 统计设备关联的组织、用户列表/{deviceId}
  DevicebindAll: '/dms/device/biz/bind', // 单个设备批量关联组织用户
  DeviceChangeLocation: '/dms/device/changeLocation', // 设备更改项目
  DeviceContract: '/crms/crm/contract/preDeliverList', // 待发货列表（总部、售后）
  DeviceContractReceive: '/crms/crm/contract/preReceiveList', // 待收货列表（售后、乙方）
  EcontractGetDownloadUrl: '/crms/econtract/getDownloadUrl', // [GET] {econtractId} 合同下载
  DeviceActivate: '/dms/device/activate', // 设备激活
  DeviceToUse: '/dms/device/reuse', // 设备启用
  DeviceMyUpdate: '/dms/device/my/update', // [POST]我的设备-修改项目/地点
  DeviceAutomaticUpdate: '/dms/device/automatic/update', // 组织设备-更新用户/组织与设备关联规则【自动或手动关联】
  DeviceReportDailyExport: '/report/dms/device/daily/export', // 设备日报表导出
  DeviceReportSummaryExport: '/report/dms/device/summary/export', // 设备历史报表导出
  deviceFeignCommandTask: '/dms/feign/commandTask/autoIssueBillNewDelay', // 下发账单

  deviceOrganLocation: '/dms/associate/location/organ', // 组织项目分页
  deviceUserLocation: '/dms/associate/location/page', // 已关联项目分页
  deviceLocationPage: '/dms/biz/location/page', // 所有设备项目分页

  deviceChangeSc: '/dms/device/changeSc', // [POST] 设备更改售后公司

  // 站点管理
  SitePage: '/dms/site/page', // 站点分页
  SiteAdd: '/dms/site/add', // 新增站点
  SiteUpdate: '/dms/site/update', // 编辑站点
  SiteDelete: '/dms/site/delete', // 站点删除
  SiteAssList: '/dms/site/associated/list', // 已关联设备列表
  SiteUnAssList: '/dms/site/unassociated/list', // 未关联设备列表
  SiteAssBind: '/dms/site/associate', // 关联设备
  SiteCancelBind: '/dms/site/cancelAssociate', // 移除关联设备
  SiteExport: '/dms/site/export', // 导出站点

  // DeviceStockPage: '/dms/inventory/page', // 实时库存列表
  DeviceStockCount: '/dms/inventory/count', // 实时库存统计
  DeviceStockDelay: '/dms/inventory/delayApply', // 库存延期申请
  DeviceStockRecord: '/dms/outInRecord/page', // 设备出入库记录
  DeviceStockRecordExport: '/dms/outInRecord/export', // 设备出入库记录导出
  DeviceReceivePage: '/dms/deviceContract/receive/pageList', // 合同收货
  DeviceReceiveWait: '/dms/deviceContract/change/receive', // 返库收货
  DeviceReceiveWaitBatch: '/dms/deviceContract/change/receive/batch', // 返库收货(批量)
  DeviceInfo: '/dms/device/info', // [get] {bodyNum} 获取设备详情
  DeviceResumeConfigRefresh: '/dms/device/resume/config/refresh', // 刷新配置（单个部件）

  // 设备参数配置
  DeviceResumeParamGroupList: '/dms/device/resume/paramGroup/list', // [GET]配置参数分类查询(外面参数类项)
  DeviceResumeParamList: '/dms/device/resume/param/list', // [GET]配置参数查询(弹窗详情左侧)
  DeviceResumeParamItemList: '/dms/device/resume/paramItem/list', // [GET]配置项查询
  DeviceResumeParamItemListControl: '/dms/device/resume/paramItem/list2', // [GET]配置项查询（控制中心）
  DeviceResumeParamItemSave: '/dms/device/resume/paramItem/save', // [POST]配置项保存
  DeviceResumeComponentReplace: '/dms/device/resume/component/replace', // [POST]更换组件-更换
  DeviceResumeBillUpdateStatus: '/dms/device/resume/bill/updateStatus', // [POST]更新账单状态
  DeviceResumeBillInfo: '/dms/device/resume/bill/info', // [POST]账单信息
  DeviceResumeFirmwareVersion: '/dms/device/resume/firmware/version', // [GET]设备固件版本信息
  DeviceResumeFirmwareUpList: '/dms/device/resume/firmware/upList', // [GET]设备固件可升级版本列表
  DeviceResumeFirmwareUpgrade: '/dms/device/resume/firmware/upgrade', // [POST]设备固件升级
  DeviceResumeParamItemSaveBill: '/dms/device/resume/paramItem/saveBill', // [POST]账单配置保存
  DeviceResumeDmsFaultPage: '/dms/device/resume/fault/page', //  [GET]设备故障记录
  DeviceResumeFaultExport: '/dms/device/resume/fault/export', //  [GET]设备-故障记录导出
  DeviceResumeParamItemHisList: '/dms/device/resume/paramItem/hisList', // [GET]配置项历史查询
  DeviceResumeParamItemLastArchive: '/dms/device/resume/paramItem/lastArchive', // 最后一次下发账单的配置
  DeviceResumeParamItemLastBill: '/dms/device/resume/paramItem/lastBill', // 最后一次下发账单的配置
  // 设备报表
  DeviceReportDaily: '/report/dms/device/daily', // [GET]设备日报表
  DeviceReportDailyWorkRunList: '/report/dms/device/daily/workRun/list', // [GET]设备日报表
  DeviceReportDailyBootCardList: '/report/dms/device/daily/bootCard/list', // [GET] 开机卡日报表详情
  DeviceReportDailyBootCardWorkRunList: '/report/dms/device/daily/bootCard/workRun/list', // [GET]开机卡日报表详情
  DeviceReportDailyWorkRunExport: '/report/dms/device/daily/workRun/export', // [GET]设备日报表详情导出
  // DailyBootCardDetailExport: '/dms/device/report/daily/bootCard/detail/export', // [GET]ice设备日报表详情导出
  // DeviceReportSiteCount: '/dms/device/report/site/count', //  [GET]设备路径报表统计
  // DeviceReportSiteExport: '/dms/device/report/site/export', // [GET]设备路径报表导出
  deviceReportDailyCount: '/report/dms/device/daily/count', // 设备日报表统计
  deviceReportDailyExport: '/report/dms/device/daily/export', // 设备日报表导出
  deviceReportDailyList: '/report/dms/device/daily/list', // 设备日报表列表
  deviceReportDailyPage: '/report/dms/device/daily/page', // 设备日报表分页
  DeviceReportSiteSiteList: '/report/dms/device/site/siteList', // [GET]站点下拉列表（设备路径筛选）
  DeviceReportSiteSlotList: '/report/dms/device/site/slotList', // [GET]路径下拉列表（设备路径筛选）
  DeviceDeviceReportWorkRunPage: '/report/dms/device/workRun/page', // [GET] 查ice设备的使用记录分页列表
  DeviceReportWorkRunExport: '/report/dms/device/workRun/export', // [GET]ice设备的使用记录导出
  DeviceReportHistoryExport: '/report/dms/device/history/export', // [GET] 设备报表导出
  DeviceReportDailyTime: '/report/dms/device/dailyTime', // [GET] 今日报表时间区间
  DeviceReportWorkRunCount: '/report/dms/device/workRun/count', // [GET] 使用历史详情统计
  DeviceFwList: '/dms/deviceStructure/fwList', // 静默升级部件
  DeviceSetSilentUpgrade: '/dms/device/setSilentUpgrade', // 设置非静默升级部件

  // 月报表
  DeviceReportDailyList: '/report/dms/device/daily/list', // [GET] 设备日报表分页（按月查当月日报表分页、按周查本周日报表分页）
  DeviceReportDailyPage: '/report/dms/device/daily/page', // [GET] 设备日报表分页（按月查当月日报表分页、按周查本周日报表分页）
  // 年报表
  DeviceReportSummaryInfo: '/report/dms/device/summary/count', // 设备报表详情
  DeviceReportSummaryList: '/report/dms/device/summary/list', // 设备报表列表（按年查月度报表、按季度查周报表）
  DeviceReportSummaryPage: '/report/dms/device/summary/page', // 设备统计报表分页（按年查月度报表分页、按季度查周报表分页）
  // 项目维度报表查询
  LocationDevicePage: '/report/dms/location/device/page', // 项目维度报表查询
  LocationDeviceExport: '/report/dms/location/device/export', // 项目维度报表导出
  DeptDevicePage: '/report/dms/dept/device/page', // 部门维度报表查询
  DeptDeviceExport: '/report/dms/dept/device/export', // 部门维度报表导出
  ReportDailyLocationPage: '/report/dms/reportDailyLocation/page', // 设备日报表-项目维度分页
  ReportDailyLocationExport: '/report/dms/reportDailyLocation/export', // 设备日报表-项目维度导出
  LocationDeviceMonthDetailExport: '/report/dms/location/device/monthDetail/export', // 设备月报表-项目维度导出
  // 设备电子围栏
  DeviceFenceAdd: '/dms/deviceFence/add', // 电子围栏新增
  DeviceFenceDelete: '/dms/deviceFence/delete', // 电子围栏删除
  DeviceFenceInfo: '/dms/deviceFence/info', // 电子围栏详情
  DeviceFenceList: '/dms/deviceFence/list', // 电子围栏列表
  DeviceFenceUpdate: '/dms/deviceFence/update', // 修改电子围栏
  // 设备辅助定位
  DeviceLocationAdd: '/dms/deviceLocationAuxiliary/add', // 设备辅助定位新增
  DeviceLocationDelete: '/dms/deviceLocationAuxiliary/delete', // 设备辅助定位删除
  DeviceLocationInfo: '/dms/deviceLocationAuxiliary/info', // 设备辅助定位信息
  DeviceLocationList: '/dms/deviceLocationAuxiliary/list', // 设备辅助定位列表
  DeviceLocationUpdate: '/dms/deviceLocationAuxiliary/update', // 设备辅助定位更新

  // 库存管理
  stockDeviceSale: '/dms/stock/device/sale', // 设备销售
  stockDevicePage: '/dms/stock/page', // 库存分页列表
  stockPendPage: '/dms/stock/pendingInList', // 分页列表（入库）
  stockTransferPage: '/dms/stock/transferable/page', // 设备分页(转移选择)
  stockExport: '/dms/stock/export', // 已入库导出
  stockDevicePartReplace: '/dms/stock/device/part/replace', // 零件更换
  productStructureList: '/dms/productStructure/list', // [GET]所有部件列表 分类-部件
  productStructureGetByCode: '/dms/component/getByCode', // [GET]根据编码获取详细信息
  stockOldPartInfo: '/dms/stock/oldPart/info', // [GET]旧零件信息查询
  stockNewPartInfo: '/dms/stock/newPart/info', // 新零件信息查询
  AllowRenovateDevice: '/dms/update/allowRenovate', // 设置允许翻新{deviceId}{0/1}
  allowScRenovate: '/dms/update/allowScRenovate', // 设置允许售后翻新{deviceId}{0/1}
  NextDeviceBizType: '/dms/update/nextDeviceBizType', // 设置预估设备业务类型

  // 总部库存
  FactoryStockFactoryList: '/dms/factoryStock/factoryList',
  FactoryStockPage: '/dms/factoryStock/page', // 总部库存
  FactoryStockShip: '/dms/factoryStock/ship', // 出库

  stockConfirmInStock: '/dms/stock/confirmInStock', // 确认入库
  stockSwap: '/dms/stock/swap', // 更换设备
  stockTransfer: '/dms/stock/transfer', // 转移设备
  stockTransferHq: '/dms/stock/transfer/hqToHq', // 转移设备(总部)

  stockActivate: '/dms/stock/device/activate', // 设备激活
  stockDeactivate: '/dms/stock/device/deactivate', // 设备反激活
  stockReactivate: '/dms/stock/device/reactivate', // 设备重新激活
  stockBindSite: '/dms/stock/device/bindingSite', // 设备站点绑定
  stockUnBindSite: '/dms/stock/route/remove', // 解绑站点

  stockSiteList: '/dms/stock/device/site/list', // 站点列表
  stockGroupUpdate: '/dms/stock/device/site/update', // 编辑站点保存
  stockSiteUpgrade: '/dms/stock/device/site/upgrade', // 站点升级

  bootCardBind: '/dms/bootCard/associateDevice', // 关联开机卡
  bootCardBindPwd: '/dms/bootCard/setPwd', // 关联开机密码
  bootCardBindList: '/dms/bootCard/listForDevice', // 已关联开机卡
  bootCardUnbindPage: '/dms/bootCard/unAssociate/page', // 未关联设备开机卡
  bootCardChangeUser: '/dms/bootCard/changeUser', // 设备开机卡变更使用人
  bootCardChangeUserPwd: '/dms/bootCard/changeUser4Pwd', // 设备开机卡变更使用人
  // 固件任务管理
  commandTaskPage: '/dms/command/task/page', // [GET] 固件任务列表
  commandTaskDelete: '/dms/command/task/delete', // [POST] 删除设备任务{taskId}
  commandTaskAdd: '/dms/command/task/add', // 新增任务第一步
  // tslDataList: '/dms/tsl/data/list', // [GET]固件任务新增第二步处-部件查物模型下拉 {topicId}&&{protocolId}
  // commandTaskFirmwarePage: '/dms/command/task/firmware/page', // 固件分页（固件任务新增-固件分页）
  commandTaskTslDataList: '/dms/command/task/tsl/data/list', // [GET]固件任务新增第二步处-部件查物模型下拉 {topicId}&&{protocolId}
  tslDataSelectList: '/dms/tsl/data/selectList', // [GET]物模型下的参数 {tslId}
  commandTaskUpdate: '/dms/command/task/update', // [POST] 修改设备任务 编辑 第二步 {taskId}
  commandTaskParamSave: '/dms/command/task/param/save', // [POST] 保存指令 第二步
  commandTaskDevicePage: '/dms/command/task/device/page', // [GET] 固件任务已关联和未关联设备列表 第三步列表
  commandTaskUnAssModemPage: '/dms/command/task/unAssModem/page', // [GET]未关联的modem分页
  commandTaskDeviceList: '/dms/command/task/device/list', // 任务设备列表
  firmwareSelect: '/dms/firmware/select', // [GET] 固件任务-固件版本下拉
  commandTaskDetailSave: '/dms/command/task/detail/save', // [POST] 任务关联设备
  commandTaskDetailSaveSelectedAll: '/dms/command/task/detail/save/selectedAll', // 任关联所有选中设备或modem
  commandTaskPublish: '/dms/command/task/publish', // [POST] 固件任务保存和发布 {taskId} 第三步
  commandTaskDevice: '/dms/command/task/device', // [GET] 固件任务详情 {taskId}
  // commandTaskState: '/dms/command/task/state', // [GET] 获取设备任务状态详情 {taskId}
  commandTaskOperation: '/dms/command/task/operation', // [POST] 设备任务(任务执行页重试、重新开始、结束任务)
  commandTaskOfflineTask: '/dms/command/task/offlineTask', // [POST]获取设备部件离线任务
  commandTaskExport: '/dms/command/task/export', // [GET]  导出固件
  commandTaskCancel: '/dms/command/task/cancel', // [POST] 取消任务 {taskId}
  commandTaskDetailCancel: '/dms/command/task/detail/cancel', // [POST] {taskDetailId}取消任务详情
  commandTaskDetailDelete: '/dms/command/task/detail/delete', // [POST]{taskDetailId}删除任务详情
  commandTaskBatchDetailDelete: '/dms/command/task/batch/detail/delete', // [POST]{taskDetailId}批量删除任务
  commandTaskDetailDeleteAll: '/dms/command/task/detail/deleteAll', // taskId删除全部设备
  commandTaskDetailPage: '/dms/command/task/detailPage', // 任务机器分页
  // 设备组件
  deviceStructurePage: '/dms/deviceStructure/page', // [GET] 设备组件分页列表
  deviceStructureExport: '/dms/deviceStructure/export', // [GET] 导出
  deviceStructureHwVersionUpdate: '/dms/deviceStructure/hwVersion/update', // [POST] 编辑硬件版本
  deviceStructureFwList: '/dms/deviceStructure/fwList', // 获取机器的现有的固件版本
  // 开机卡管理
  bootCardPage: '/dms/bootCard/page', // [GET]开机卡分页列表
  bootCardAdd: '/dms/bootCard/add', // [POST] 新增开机卡
  bootCardExport: '/dms/bootCard/export', // [GET]导出开机卡
  bootCardDelete: '/dms/bootCard/delete', // [POST]{cardId}删除开机卡
  bootCardInfo: '/dms/bootCard/info', // [GET]{cardId}开机卡详情
  bootCardUpdate: '/dms/bootCard/update', // [POST]修改DmsBootCard对象
  bootCardCheckDataPage: '/dms/bootCard/checkData/page', // [GET] 获取excel检查数据列表
  bootCardExcel: '/dms/bootCard/excel', // [POST]上传excel
  bootCardExportExpData: '/dms/bootCard/exportFailData', // [GET]导出检测异常数据
  bootCardImport: '/dms/bootCard/import', // [POST]{flag}确认导入
  bootCardImportTemplate: '/dms/bootCard/downloadTemplate', // [GET]下载开机卡导入模板
  bootCardAssociateDeviceRefresh: '/dms/bootCard/associateDevice/refresh', // [POST]/{deviceId}刷新已关联开机卡

  // 设备报废管理
  deviceScrapApply: '/dms/deviceScrap/apply', // 报废申请
  deviceScrapApplyDetail: '/dms/deviceScrap/applyDetail', // 报废申请详情查看
  deviceScrapApplyExport: '/dms/deviceScrap/applyExport', // 设备报废申请导出
  deviceScrapApplyPage: '/dms/deviceScrap/applyPage', // 设备报废管理分页列表
  deviceScrapApproval: '/dms/deviceScrap/approval', // 报废审批

  deviceScrapDetail: '/dms/deviceScrap/detail', // 报废申请详情查看

  deviceScrapExport: '/dms/deviceScrap/export', // 设备报废申请导出
  deviceScrapPage: '/dms/deviceScrap/page', // 设备报废管理分页列表
  deviceScrapSetReturnType: '/dms/deviceScrap/setReturnType', // 设置返回类型
  DeviceScrapBatch: '/dms/deviceScrap/batch', // [POST]批量翻新-批量入库{flag}
  DeviceScrapExcel: '/dms/deviceScrap/excel', // [POST]批量翻新检测导入
  DeviceScrapExcelCheckPage: '/dms/deviceScrap/excel/checkPage', // [GET]批量翻新-验证通过数据分页查询
  DeviceScrapExcelExportFailData: '/dms/deviceScrap/excel/exportFailData', // [GET]批量翻新-导出异常数据
  DeviceScrapDownloadTemplate: '/dms/deviceScrap/downloadTemplate', // [GET]下载导入模板
  DeviceScrapDelete: '/dms/deviceScrap/delete', // [POST] 报废申请详情查看
  DeviceScrapSetReturnTypeBatch: '/dms/deviceScrap/setReturnTypeBatch', // [POST]编辑批量设置返回类型
  DeviceScrapSetUpdateReasonBatch: '/dms/deviceScrap/updateReasonBatch', // [POST]审批编辑修改报废原因

  // 赠送配件管理
  giveawayPage: '/crms/rms/giveaway/page', // [GET] 赠送配件列表
  giveawayDetail: '/crms/rms/giveaway/detail', // [GET] 赠送配件详情
  giveawayExport: '/crms/rms/giveaway/export', // [GET] 赠送配件导出
  giveawayCount: '/crms/rms/giveaway/count', // [GET] 赠送配件数量统计
  giveawayReplace: '/crms/rms/giveaway/replace', // [POST] 更换配件
  giveawaySelect: '/crms/rms/giveaway/select', // [GET] 可修改配件下拉选
  giveawayConfirm: '/crms/rms/giveaway/confirm', // [POST] 确认
  giveawayCancel: '/crms/rms/giveaway/cancel', // [POST] 作废
  giveawayLog: '/crms/rms/giveaway/log', // [GET] 业务日志列表
  giveawayShipDetail: '/crms/rms/giveaway/ship/detail', // [GET] 赠送配件发货详情
  giveawayFinishBatch: '/crms/rms/giveaway/finish/batch', // [POST] 赠送配件发货-完成
  giveawayDelete: '/crms/rms/giveaway/delShip', // [POST] 赠送配件发货-删除发货单
  giveawayBatchConfirm: '/crms/rms/giveaway/batch/confirm', // [POST]批量确认
  giveawayRePush: '/crms/rms/giveaway/rePush', // [POST] 同步出库单
  // 分成规则管理
  SharingRuleAdd: '/crms/rms/sharingRule/add', // 新增分成规则
  SharingRulePage: '/crms/rms/sharingRule/page', // 分成规则分页列表
  SharingRuleDelete: '/crms/rms/sharingRule/delete', // 删除分成规则{/sharingRuleId}
  SharingRuleInfo: '/crms/rms/sharingRule/info', // 查看分成规则
  SharingRuleUpdate: '/crms/rms/sharingRule/update', // 修改分成规则{/sharingRuleId}
  // 租赁方案
  SchemePaymentAdd: '/crms/crm/schemePayment/add', // 添加租赁方案
  SchemePaymentDelete: '/crms/crm/schemePayment/delete', // 删除租赁方案{schemeId}
  SchemePaymentInfo: '/crms/crm/schemePayment/info', // 查看用 {/schemeId}
  SchemePaymentPage: '/crms/crm/schemePayment/page', // 分页列表
  SchemePaymentUpdate: '/crms/crm/schemePayment/update', // 修改{/schemeId}
  SchemePaymentDetail: '/crms/crm/schemePayment/updateInfo', // 编辑用{/schemeId}
  SchemePaymentState: '/crms/crm/schemePayment/updateState', // 启用禁用方案

  // 新租赁方案类目
  CategoryAdd: '/crms/rms/category/add', // 添加类目
  CatgoryUpdate: '/crms/rms/category/update', // 更新类目
  CategodyDelete: '/crms/rms/category/delete', // 删除类目
  CategoryInfo: '/crms/rms/category/info', // 查看类目
  CategoryTree: '/crms/rms/category/tree', // 类目树
  // 新租赁方案
  GoodsPage: '/crms/rms/goods/page', // 租赁商品分页列表
  GoodsAdd: '/crms/rms/goods/add', // 新增租赁商品信息
  GoodsUpadte: '/crms/rms/goods/update', // 修改租赁商品信息
  GoodsDelete: 'crms/rms/goods/delete', // 删除商品信息
  GoodsState: 'crms/rms/goods/setState', // 商品状态
  GoodsInfo: '/crms/rms/goods/info', // 查看商品信息
  // 新租赁方案sku
  GoodsSkuAdd: '/crms/rms/goods/saveSku', // 新增商品sku
  GoodsSkuUpdate: '/crms/rms/goods/updateSku', // 更新商品sku
  GoodsSkuDelete: '/crms/rms/goods/deleteSku', // 删除商品sku
  GoodsSkuList: '/crms/rms/goods/skuList', // 获取商品sku列表
  GoodsSkuSet: '/crms/rms/goods/setBreak', // 设置违约金
  GoodsSkuGetSet: '/crms/rms/goods/getBreak', // 查看违约方案
  OrganJvList: '/base/organ/jvList', // 租赁方案适用公司
  OrderGoodsPage: '/crms/rms/orderGoods/page', // 租赁订单
  OrderGoodsExport: '/crms/rms/orderGoods/export', // 租赁订单导出

  // 租赁方案分类
  SchemeClassAdd: '/crms/crm/schemeClass/add', // 添加方案分类
  SchemeClassDelete: '/crms/crm/schemeClass/delete', // 删除方案分类
  SchemeClassList: '/crms/crm/schemeClass/list', // 获取方案分类列表
  SchemeClassUpdate: '/crms/crm/schemeClass/update', // 修改租赁方案

  // 库存费方案
  stockCostSchemeAdd: '/crms/crm/stockRule/add', // 添加库存管理费方案
  stockCostSchemeDelete: '/crms/crm/stockRule/delete', // 删除库存管理费方案/{costSchemeId}
  stockCostSchemePage: '/crms/crm/stockRule/page', // 库存管理费方案分页列表
  stockCostSchemeDefault: '/crms/crm/stockRule/setDefault', // 设置默认方案/{costSchemeId}
  stockCostSchemeGetDefault: '/crms/crm/stockRule/getDefault', // 获取默认方案/{costSchemeId}
  stockCostSchemeUpdate: '/crms/crm/stockRule/update', // 修改库存管理费方案/{costSchemeId}

  // 赠品规则
  giveawayRuleAdd: '/crms/ruleGiveaway/add', // 新增赠品规则
  giveawayRuleDel: '/crms//ruleGiveaway/delete', // 删除赠品规则表/{id}
  giveawayRuleInfoGoods: '/crms/ruleGiveaway/info/goods', // 规则赠品详情集合/{giveawayRuleId}
  giveawayRuleInfo: '/crms/ruleGiveaway/info/', // 规则配置详情/{giveawayRuleId}
  giveawayRulePage: '/crms/ruleGiveaway/page', //  赠品规则分页
  giveawayRuleUpdate: '/crms/ruleGiveaway/update', //  修改赠品规则表 /{giveawayRuleId}

  // 售后公司
  partnerPage: '/crms/crm/partner/page', // [GET]查询售后公司分页列表
  partnerSelectAgent: '/crms/crm/partner/select/agent', // [GET] 代理公司
  partnerAdd: '/crms/crm/partner/add', // [POST]新增
  partnerDelete: '/crms/crm/partner/delete', // [POST]{id}
  partnerInfo: '/crms/crm/partner/info', // [GET]{id} 查询售后公司详情
  partnerCustomerPage: '/crms/crm/partner/customer/page', // [GET] 售后公司或集团下租赁方分页列表
  partnerSimilarCustomerPage: '/crms/crm/partner/similarCustomer/page', // [GET] 查询相似租赁方分页列表（租赁方审核）
  partnerSimilarCustomerLink: '/crms/crm/partner/similarCustomer/link', // 关联相似租赁方
  partnerLargeCustomerCustomerLink: '/crms/crm/partner/largeCustomer/customer/link', // [POST]集团批量关联租赁方
  partnerlargeCustomerCustomerUnlink: '/crms/crm/partner/largeCustomer/customer/unlink/', //  [POST] {partnerId}删除集团下关联租赁方
  partnerContractInfoPage: '/crms/crm/partner/contractInfo/page', // [GET] 查询合作伙伴的合同列表
  stockRealtimePageList: '/dms/inventory/page', // [GET]查询合作伙伴的设备列表
  partnerFactoryService: '/crms/crm/partner/factory/service/page', // [GET]获取总部下的售后公司列表
  serviceAreaList: '/crms/crm/serviceArea/list', // [GET]获取售后区域列表{serviceAreaId}
  serviceAreaUpdate: '/crms/crm/serviceArea/update', // [POST]更改售后区域
  partnerUpdateState: '/crms/crm/partner/update/state', // [POST]更改合作伙伴状态
  partnerInfoAndReal: '/crms/crm/partner/infoAndReal', // [GET]获取合作伙伴信息-包括实名认证信息
  bestsginUserCertInfo: '/crms/crm/bestsgin/user/cert/info', // [GET]获取证书详细信息
  deviceBizStockPage: '/dms/device/biz/stock/page', // 分页查询组织库存设备（默认查当前登录人组织）
  PartnerAfterServicePartnerType: '/crms/crm/partner/afterService/partnerType', // [GET] 新增售后公司时查可选的合作伙伴类型
  // PartnerHqAfterService: '/crms/crm/partner/select/hqAndAfterService', // 获取总部和售后公司列表（废弃，用PartnerHqSc）
  PartnerHqSc: '/crms/rms/order/change/select/hqAndSc', // 获取公司列表
  CrmServiceAreaList: '/crms/crm/serviceArea/list', // 获取售后区域列表
  contractList4Partner: '/crms/contract/list4Partner', // [GET]获取合作伙伴下的合同列表
  crmServiceAreaList4Hq: '/crms/crm/serviceArea/list4Hq', // [GET]获取所属总部服务区域列表
  crmServiceAreaList: '/crms/crm/serviceArea/list', // [GET]获取所属总部服务区域列表
  contractCount4Partner: '/crms/contract/count4Partner', // {partnerId}合作伙伴下的合同统计（饼图）
  deviceBizCountBizType: '/dms/device/biz/count/bizType', // {partnerOrgId}//根据设备类型统计设备数量
  crmPartnerAdd4Simple: '/crms/crm/partner/add4Simple', // [POST] 添加合作伙伴（简化版）
  crmPartnerUpdate4Simple: '/crms/crm/partner/update4Simple', // [POST]修改合作伙伴（简化版）
  crmPartnerExport: '/crms/crm/partner/export', // 合作伙伴导出
  crmPartnerLargeCustomerLocationUnlinkPage: '/crms/crm/partner/largeCustomer/location/unlink/page', // [GET] 集团下关联的地区分页列表

  // 合作伙伴 发票主体
  crmPartnerInvoiceAdd: '/crms/crm/partnerInvoice/add', // [POST]发票主体-新增
  crmPartnerInvoiceDelete: '/crms/crm/partnerInvoice/delete', //  [POST]发票主体-删除{partnerInvoiceId}
  crmPartnerInvoiceInfo: '/crms/crm/partnerInvoice/info', // [GET] 发票主体-详情
  crmPartnerInvoiceItemBatchAdd: '/crms/crm/partnerInvoice/item/batch/add', //  [POST]发票明细-新增
  crmPartnerInvoiceItemDelete: '/crms/crm/partnerInvoice/item/delete', //  [POST]{partnerInvoiceItemId}发票明细-删除
  crmPartnerInvoiceItemInfo: '/crms/crm/partnerInvoice/item/info', // [GET] {partnerInvoiceItemId}发票明细-详情
  crmPartnerInvoiceItemPage: '/crms/crm/partnerInvoice/item/page', // [GET] 发票明细-分页
  crmPartnerInvoiceItemUpdate: '/crms/crm/partnerInvoice/item/update', // [POST] 发票明细-编辑
  crmPartnerInvoicePage: '/crms/crm/partnerInvoice/page', // [GET] 发票主体-分页
  crmPartnerInvoiceUpdate: '/crms/crm/partnerInvoice/update', //  [POST]发票主体-编辑
  crmPartnerInvoiceUpdateIsDefault: '/crms/crm/partnerInvoice/update/isDefault', //  [POST]{partnerInvoiceId}发票主体-设置默认
  crmPartnerInvoiceList: '/crms/crm/partnerInvoice/list', // 组织的发票主体-下拉列表

  // 销售订单变更设备
  ChangeOrderSaleDevice: '/crms/sms/order/change/device/list', // 变更设备/终止销售设备列表(销售)
  ChangeOrderSaleInfo: '/crms/sms/order/change/info', // 变更订单详情(销售)
  ChangeOrderSaleSelectAd: '/crms/sms/order/change/select/hqAndSc', // 设备退回地址下拉(销售)
  ChangeOrderSaleBill: '/crms/sms/order/change/bills', // 终止设备账单详情(销售)
  ChangeOrderSaleSave: '/crms/sms/order/change/orderDevice/saveOrUpdate', // 保存变更设备(销售)
  ChangeStopSaleSave: '/crms/sms/order/change/stopSale/saveOrUpdate', // 保存终止设备(销售)

  SaleOrderConfirmSale: '/crms/saleOrder/confirmSale', // 确认售卖

  // 订单变更管理
  ChangeOrderInfo: '/crms/rms/order/info', // 变更订单详情
  OrderChangeDelete: '/crms/rms/order/change/delete', // 变更删除
  deviceBreakRecordExport: '/crms/rms/order/change/device/break/record/export', // 设备违约记录导出
  deviceBreakRecordPage: '/crms/rms/order/change/device/break/record/page', // 设备违约记录分页列表
  OrderChangeDeviceList: '/crms/rms/order/change/device/list', // 变更设备列表
  OrderChangeManageList: '/crms/rms/orderChangeDevice/list', // 变更设备列表（变更管理）
  OrderChangeInfo: '/crms/rms/order/change/info', // 变更详情（编辑用）
  OrderChangePage: '/crms/rms/order/change/page', // 变更分页
  OrderDeviceSave: '/crms/rms/order/change/orderDevice/saveOrUpdate', // 变更设备保存
  StopContractSave: '/crms/rms/order/change/stopContract/saveOrUpdate', // 终止合同保存
  StopTestSave: '/crms/rms/order/change/stopTest/saveOrUpdate', // 终止测试保存
  PauseUseSave: '/crms/rms/order/change/pauseUse/saveOrUpdate', // 暂停试用保存
  PaymentSave: '/crms/rms/order/change/paymentPeriod/saveOrUpdate', // 变更支付周期保存
  ChangeStartDateSave: '/crms/rms/order/change/rentTime/saveOrUpdate', // 变更起租日期保存
  AfterServiceSave: '/crms/rms/order/change/afterService/saveOrUpdate', // 变更售后公司保存
  StopDeviceRent: '/crms/rms/order/change/stopRent/saveOrUpdate', // 终止设备租赁保存
  ContinueRentAdd: '/crms/crm/contract/renewal/add', // 续租合同新增（第一步）
  ContinueRentUpdate: '/crms/crm/contract/renewal/update', // 续租合同编辑（第一步）
  TestToRentAdd: '/crms/crm/contract/trialToLease/add', // 试用转租赁新增（第一步）
  TestToRentUpdate: '/crms/crm/contract/trialToLease/update', // 试用转租赁编辑（第一步）
  OrderChangeDevice: '/crms/rms/orderChangeDevice/break/info', // 设备违约信息
  OrderGoodsContract: '/crms/crm/contract/listForScheme', // 租赁方案下的合同列表

  // 合同变更管理
  ContractBeforeChange: '/crms/crm/contract/change/before/order/device', // 变更合同中产品型号数量（发货前）
  ContractStartChange: '/crms/crm/contract/change/order/device', // 设备变更（变更启租日期、售后公司、终止合同、变更设备、变更数量）
  ContractDeviceList: '/crms/crm/contract/order', // 合同设备列表（包含产品型号）
  ContractDeviceList1: '/dms/device/contract/state/list', // 合同设备列表1（包含设备状态）
  ContractChange: '/crms/rms/order/change/order/page', // 合同变更管理分页
  ContractDetail: '/crms/crm/contract/change/info', // 合同变更详情
  ContractOutPage: '/crms/lms/order/outPage', // 合同发货记录列表
  ContractDevicePage: '/crms/rms/orderDevice/deviceList', // 合同设备分页列表
  ContractDeviceCount: '/crms/rms/orderDevice/deviceCount', // 合同设备统计
  ContractDeliverPage: '/dms/deviceContract/deliverList', // 总部/售后待发货列表,[cibtractId]售后、乙方待收货列表
  ContractChangeLog: 'crms/crm/contract/log', // 合同变更记录
  // 合同账单
  ContractDetailBillPage: '/fms/billOrder/pageForOrder', // 合同账单分页列表（合同详情页使用）
  ContractBillCount: '/fms/billOrder/countForOrder', // 合同账单统计
  ContractBillOrderListForOrderDevice: '/fms/billOrder/listForOrderDevice', // 订单设备账单分页列表（租赁确认单使用）

  partnerLargeCustomerCustomerUnlinkList: '/crms/crm/partner/largeCustomer/customer/unlink/list', // [GET]/{partnerId} 查询集团未关联的租赁方
  partnerLargeCustomerCustomerUnlinkPage: '/crms/crm/partner/largeCustomer/customer/unlink/page', // [GET]/{partnerId} 查询集团未关联的租赁方
  // partnerUpdateLargeCustomerCustomerRelationType: '/crms/crm/partner/update/largeCustomer/customer/relationType', // [POST] 修改关联设备关系
  partnerLargeCustomerCustomerRelationType: '/crms/crm/partner/largeCustomer/customer/relationType', // POST] 修改关联设备关系

  // deviceLargeCustomerNotAssDevice: '/dms/device/biz/page', // 集团客户与租赁方之间未关联的设备列表

  partnerApproveCustomer: '/crms/crm/partner/approve/customer', // 租赁方审批
  partnerUpdate: '/crms/crm/partner/update', // [POST]更新 /{id}
  deviceBizPage: '/dms/device/biz/page', // [Get]获取售后公司 设备

  partnerContact: '/crms/crm/partner/contact/list', // [GET]查询联系人列表
  partnerContactAdd: '/crms/crm/partner/contact/add', // [POST]新增  售后公司 联络人
  partnerContactBatchAdd: '/crms/crm/partner/contact/batch/add', // [POST]批量添加联系人
  partnerContactDelete: '/crms/crm/partner/contact/delete', // {id}  [POST]删除合作伙伴联系人
  partnerContactUpdate: '/crms/crm/partner/contact/update', // [POST]更新联系人
  partnerContactBusiness: '/crms/crm/partner/contact/business/', // [Get]{id}获取业务 管理联系人
  partnerFactoryUnAssign: '/crms/crm/partner/factory/unAssignServiceList', // 获取总部下未分配售后的售后公司列表

  // 组织管理员
  // partnerContactInof: '/partner/contact/info', // [GET] {id} 查询联络人详情
  partnerOrganAdmin: '/base/admin/add', // [POST]新增  管理员
  partnerOrganAdminUpdate: '/base/admin/change', // 修改平台管理员
  partnerOrganAdminList: '/base/admin/users', // [GET] 查询过滤自己 其他管理员
  partnerOrganAdminItem: '/base/admin', // [GET] {organId} 查询管理员
  partnerOrganAdminPwd: '/base/admin/pwd/update', // 修改管理员密码

  // 合同操作
  // contractGetPageList: '/crms/crm/contract/page', // [GET]获取合同列表页
  crmContractLeasingPage: '/crms/crm/contract/leasing/page', // [GET]租赁合同/框架协议分页列表
  crmContractLeasingExport: '/crms/crm/contract/leasing/export', // [GET]租赁合同/框架协议分页导出
  crmContractOrderPage: '/crms/crm/contract/order/page', // [GET]协议订单分页列表
  crmContractOrderExport: '/crms/crm/contract/order/export', // [GET]协议订单导出
  contractAdd: '/crms/crm/contract/add', // [POST]新增合同基本信息
  contractInfo: '/crms/crm/contract/info', // [GET]获取合同信息
  contractDelete: '/crms/crm/contract/delete/', // [DELETE]{id}删除
  contractUpdate: '/crms/crm/contract/update', // [PUT]{contractId}保存基本信息
  contractSavePartner: '/crms/crm/contract/savePartner', // [PUT]{contractId}保存甲乙方信息
  contractSaveAfterService: '/crms/crm/contract/saveAfterService', // [PUT]{contractId}保存服务中心
  contractSaveDevice: '/crms/crm/contract/saveDevice', // [PUT]{contractId}保存关联设备信息(租赁方案)
  contractSaveDownPayment: '/crms/crm/contract/saveDownPayment', // [PUT]{contractId}保存首付款信息
  contractSaveSign: '/crms/crm/contract/saveSign', // [PUT]{contractId}保存签订信息
  contractSubmit: '/crms/crm/contract/submit', // [PUT]{contractId}合同提交
  contractAudit: '/crms/crm/contract/audit', // [PUT]{contractId}合同审批
  contractSendBack: '/crms/crm/contract/sendBack', // [PUT]{contractId}合同退回
  contractDeliver: '/crms/crm/contract/deliver', // [PUT]{contractId}发货
  contractReceive: '/crms/crm/contract/receive', // [PUT]{contractId}收货
  contractOrderList: '/crms/crm/contract/orderList', // 合同设备列表
  contractEndPauseUse: '/crms/rms/order/change/endPauseUse', // 设备恢复使用
  contractDeviceStart: '/crms/rms/orderDevice/startLease', // 设备启租
  contractDeviceStart2: '/crms/rms/orderDevice/startLeaseV2', // 设备启租v2
  contractGiveawayList: '/crms/rms/giveaway/pageForOrder', // 订单赠送配件
  partnerGetCustomerList: '/crms/crm/partner/getCustomerList', // [GET] 获取乙方信息（租赁方）
  partnerGetPartyA: '/crms/crm/partner/getPartyA', // [GET]获取所有的售后公司列表
  partnerSelectPartnerLimit: '/crms/crm/partner/select/partner/limit', // 合作下拉查询（前20条）
  partnerListCoByCs: '/crms/crm/partner/listCoByCs', // 获取乙方的所属大客户列表
  contractGetFactory: '/crms/crm/partner/getFactory', // [GET]获取当前登录人关联的总部信息
  contractApprove: '/crms/crm/contract/change/approve', // 合同变更审批
  contractChangeCancel: '/crms/crm/contract/change/cancel', // 合同变更取消
  partnerAllService: '/crms/crm/partner/allService', // [GET]获取所有的售后公司列表
  schemePaymentSelectPage: '/crms/crm/schemePayment/selectPage', // [GET]租赁方案分页列表（合同新增选择方案时用）
  crmPartnerBankcardAvailableList: '/crms/crm/crmPartnerBankcard/available/list', // [GET]租赁方案分页列表（合同新增选择方案时用）
  crmBestsginTemplateGetTemplates: '/crms/crm/bestsgin/template/getTemplates', // [POST]获取模版列表
  crmBestsginTemplatePreview: '/crms/crm/bestsgin/template/preview', // [POST]预览模板 需要合作伙伴营业执照号
  rmsGoodsSelectSkuList: '/crms/rms/goods/skuSelectList', // [GET]sku列表 合作第二步 选择租赁方案
  crmContractSaveScheme: '/crms/crm/contract/saveScheme', // [POST]sku列表 合作第二步 选择租赁方案
  crmContractListScheme: '/crms/crm/contract/listScheme', // [GET]获取合同已关联的租赁方案
  crmPartnerGetFactory: '/crms/crm/partner/getFactory', // [GET]首付款获取总部信息
  crmContractSavePrepayment: '/crms/crm/contract/savePrepayment', // [POST]保存首付款
  crmContractGetPrepayment: '/crms/crm/contract/getPrepayment', // 查询首付款
  crmsCrmPartnerGetLargeCustomerList: '/crms/crm/partner/getLargeCustomerList', // [GET]大客户协议合同获取乙方信息下拉  查询集团客户
  crmContractPreviewContract: '/crms/crm/contract/previewContract', // [GET]{contractId}预览电子合同
  crmContractSendEContract: '/crms/crm/contract/sendEContract', // [GET]{contractId}发送电子合同
  crmContractSaveAttach: '/crms/crm/contract/saveAttach', // [GET]纸质合同附件关联
  rmsGoodsCopyGoods: '/crms/rms/goods/copyGoods', // 保存定制化的sku（框架协议第二步，定制化第一步）
  rmsGoodsSkuList: '/crms/rms/goods/skuList', // sku列表
  rmsGoodsSelectList: '/crms/rms/goods/selectList', // sku childrenList列表
  smsGoodsSelectList: '/crms/sms/goods/selectList', // [GET]耗材下拉选择列表
  crmContractFrameworkList: '/crms/crm/contract/frameworkList', // 获取当前总部下的框架协议列表
  crmContractSaveStuff: '/crms/crm/contract/saveStuff', // 保存耗材（协议订单专属）
  crmContractFrameOrderStuffList: '/crms/crm/contract/frameOrder/stuffList', // 获取指定框架订单的耗材列表
  crmContractPartnerSelectList: '/crms/crm/contract/partner/selectList', // 合同合作伙伴高级搜索下拉选
  crmContractConfirmInfo: '/crms/crm/contract/confirm/info', // 租赁确认单
  crmContractCopy: '/crms/crm/contract/copy', // [POST]合同新增

  // 服务公司分摊
  invoiceAllocationAmountControllerExport: '/fms/invoiceAllocationAmountController/export', // 导出

  // 试用订单
  trialOrderAdd: '/crms/trialOrder/add', // 合同新增
  trialOrderInfo: '/crms/trialOrder/info', // 试用订单详情
  trialOrderListScheme: '/crms/trialOrder/listScheme', // 获取合同已关联的租赁方案
  trialOrderPage: '/crms/trialOrder/page', // 试用订单分页列表
  trialOrderExport: '/crms/trialOrder/export', // 试用订单分页列表
  trialOrderSaveScheme: '/crms/trialOrder/saveScheme', // 关联租赁方案
  trialOrderUpdate: '/crms/trialOrder/update', // 合同编辑
  trialOrderCopy: '/crms/trialOrder/copy', // 合同拷贝
  orderDeviceTrialPage: '/crms/rms/orderDevice/trial/page', // [GET] 试用订单设备维度分页列表
  orderDeviceTrialExport: '/crms/rms/orderDevice/trial/export', // [GET] 试用订单设备维度导出
  trialOrderClose: '/crms/trialOrder/close', // 关闭订单
  billOrderTestFreeAdd: '/fms/billOrderTest/free/add', // [POST] 试用账单免收提交/保存
  billOrderTestFreeInfo: '/fms/billOrderTest/free/info', // {changeId} [GET] 试用账单免收申请-详情
  billOrderTestFreeUpdate: '/fms/billOrderTest/free/update', // [POST] 试用账单免收申请-编辑
  trialOrderDeviceToLeaseList: '/crms/trialOrder/device/toLeaseList', // 可试用转租赁设备列表
  shipPlanDeviceSelect: '/crms/shipPlan/device/select', // 可选设备列表
  // 大客户协议(框架协议)
  // crmFrameContractAdd: '/crms/crm/frameContract/add', // 合同新增
  // crmFrameContractInfo: '/crms/crm/frameContract/info', // 合同详情
  // crmFrameContractListScheme: '/crms/crm/frameContract/listScheme', // 获取合同已关联的租赁方案
  // crmFrameContractPage: '/crms/crm/frameContract/page', // 合同分页列表
  // crmFrameContractSaveAttach: '/crms/crm/frameContract/saveAttach', // 纸质合同附件关联
  // crmFrameContractSaveScheme: '/crms/crm/frameContract/saveScheme', // 关联租赁方案
  // crmFrameContractUpdate: '/crms/crm/frameContract/update', // 合同编辑

  // 租售订单
  saleOrderDeviceOrderPage: '/crms/saleOrder/device/order/page', // [GET] 销售订单设备维度分页列表
  saleOrderDeviceExport: '/crms/saleOrder/device/export', // [GET] 销售订单设备维度导出
  saleOrderPage: '/crms/saleOrder/page', // [GET]租售订单分页列表
  saleOrderExport: '/crms/saleOrder/export', // [GET]租售订单导出
  saleOrderAdd: '/crms/saleOrder/add', // [POST]租售订单新增
  saleOrderUpdate: '/crms/saleOrder/update', // [POST]租售订单新增
  saleOrderInfo: '/crms/saleOrder/info', // [GET]租售订单详情
  partnerGetSaleCustomerList: '/crms/crm/partner/getSaleCustomerList', // [GET]获取租售订单乙方下拉选（租赁方或服务公司）
  saleOrderSaveScheme: '/crms/saleOrder/saveScheme', // [POST]保存销售方案
  saleOrderListScheme: '/crms/saleOrder/listScheme', // [GET] 销售方案列表
  saleOrderDeviceSelectPage: '/crms/saleOrder/device/selectPage', // [GET]可销售设备列表
  saleOrderDevicePage: '/crms/saleOrder/device/pageForOrder', // 租售订单设备列表
  saleOrderDeviceCount: '/crms/saleOrder/device/deviceCount', // 租售订单设备统计
  saleOrderPreDeliver: '/crms/saleOrder/preDeliverList', // 工厂售后待发货列表
  simServiceSelectList: '/crms/sms/goods/simService/selectList', // 数据服务选择列表
  orderDeviceValidList: '/crms/rms/orderDevice/validList', // 有效设备列表
  orderDeviceLeasingPage: '/crms/rms/orderDevice/leasing/page', // [GET] 租赁合同设备维度分页列表
  contractChangeSalesman: '/crms/crm/contract/changeSalesman', // 修改项目负责人
  saleOrderDeviceValidList: '/crms/saleOrder/device/validList', // 有效设备列表
  saleOrderChangeSalesman: '/crms/saleOrder/changeSalesman', // 租售合同修改业务负责人
  orderDeviceOrderPage: '/crms/rms/orderDevice/order/page', // [GEt] 协议订单设备维度分页列表
  orderDeviceOrderExport: '/crms/rms/orderDevice/order/export', // [GET] 协议订单设备维度导出
  orderDeviceLeasingExport: '/crms/rms/orderDevice/leasing/export', // [GET] 租赁合同设备维度导出

  // 项目管理
  projectAdd: '/crms/crm/project/add', // [POST]新增项目
  projectUpdate: '/crms/crm/project/update', // [POST] 修改项目信息
  projectList: '/crms/crm/project/list', // [GET]获取项目列表 下拉
  contractChangeProjectLeader: '/crms/crm/contract/changeProjectLeader', // [PUT]修改项目负责人/{contractId}
  projectDelete: '/crms/crm/project/delete', // [POST] 删除项目{projectId}
  projectPage: '/crms/crm/project/page', // [GET] 项目信息分页
  // locationList: '/dms/location/list', // [GET] 项目列表
  locationAdd: '/dms/location/add', // [POST]项目新增
  locationBizPage: '/dms/location/biz/page', // 项目列表
  locationDelete: '/dms/location/delete', // [POST]{locationId}项目删除
  locationFloorAdd: '/dms/location/floor/add', // [POST]楼层新增
  locationFloorDelete: '/dms/location/floor/delete', // [POST]{floorId}楼层删除
  locationFloorInfo: '/dms/location/floor/info', // 楼层详情
  locationfloorlist: '/dms/location/floor/list', // [GET]楼层列表
  locationFloorSort: '/dms/location/floor/sort', // [POST]楼层排序
  locationFloorUpdate: '/dms/location/floor/update', // [POST]楼层编辑
  locationInfo: '/dms/location/info', // [GET]项目详情
  locationList: '/dms/location/list', // [GET]项目列表
  locationPage: '/dms/location/page', // [GET]项目分页列表
  locationSiteAdd: '/dms/location/site/add', // [POST]区域新增
  locationSiteDelete: '/dms/location/site/delete', // [POST]{siteId}区域删除
  locationSiteInfo: '/dms/location/site/info', // [GET]区域详情
  locationSiteList: '/dms/location/site/list', // [GET]区域列表
  locationSiteAllList: '/dms/location/site/allList', // [GET]全部区域列表
  locationSitePage: '/dms/location/site/page', // [GET]区域列表
  locationSiteSelectList: '/dms/location/site/select/list', // [GET]区域下拉列表
  locationSiteSort: '/dms/location/site/sort', // [POST]区域排序
  locationSiteUpdate: '/dms/location/site/update', // [POST]区域编辑
  locationSiteSetGoal: '/dms/location/site/setGoal', // 设置区域目标
  locationTagAdd: '/dms/location/tag/add', // [POST]标签新增
  locationTagDelete: '/dms/location/tag/delete', // [POST]{tagId}标签删除
  locationTagList: '/dms/location/tag/list', // [GET]标签列表
  locationTagUpdate: '/dms/location/tag/update', // [POST]标签编辑
  locationUpdate: '/dms/location/update', // [POST]项目编辑
  locationTree: '/dms/location/tree', // 项目树
  locationDeviceAssociate: '/dms/location/device/associate', // [POST]关联设备
  locationDevicePage: '/dms/location/device/page', // [GET] 已关联设备列表
  locationDevicePreAssociatePage: '/dms/location/device/preAssociate/page', // [GET]预关联设备列表
  locationDeviceCancelAssociate: '/dms/location/device/cancelAssociate', // [POST]解绑设备
  partnerDeliverAddress: '/crms/crm/crmPartnerDeliverAddress/page', // [GET]收货地址列表
  partnerDeliverAddressAdd: '/crms/crm/crmPartnerDeliverAddress/add', // [POST]新增地址
  partnerDeliverAddressDefualt: '/crms/crm/crmPartnerDeliverAddress/defualt', // [POST]设置默认{id}
  partnerDeliverAddressDelete: '/crms/crm/crmPartnerDeliverAddress/delete', // [DELETE]删除地址{id}
  partnerDeliverAddressUpdate: '/crms/crm/crmPartnerDeliverAddress/update', // [PUT]修改地址
  partnerDeliverAddressAddByPartnerId: '/crms/crm/crmPartnerDeliverAddress/addByPartnerId', // 租赁方新增地址(合同地址)partnerId
  partnerDeliverAddressAddByPartnerOrgId: '/crms/crm/crmPartnerDeliverAddress/addByPartnerOrgId', // 租赁方新增地址(合同地址)PartnerOrgId
  partnerDeliverAddressListByPartnerId: '/crms/crm/crmPartnerDeliverAddress/listByPartnerId', // 查询当前租赁方的地址PartnerId
  partnerDeliverAddressListByPartnerOrgId: '/crms/crm/crmPartnerDeliverAddress/listByPartnerOrgId/page', // 查询当前租赁方的地址PartnerOrgId
  organSonList: '/base/organ/sonList', // 项目所属公司下拉
  bizLocationPage: '/dms/biz/location/page', // 组织设备已/未关联项目分页列表
  deviceBindAutomaticBatchSave: '/dms/deviceBindAutomatic/batchSave', // 批量绑定项目
  deviceBindAutomaticBatchDelete: '/dms/deviceBindAutomatic/batch/delete', // 批量解绑项目
  locationBasicGoalRefresh: '/dms/location/basicGoal/refresh', // [POST]刷新基准目标值
  locationBizExport: '/dms/location/biz/export', // [GET] 项目列表导出
  locationSiteBizPage: '/dms/location/site/biz/page', // [GET]区域列表
  locationSiteBizExport: '/dms/location/site/biz/export', // [GET]区域列表导出
  locationSiteSetGoalSelfBatch: '/dms/location/site/setGoalSelf/batch', // 批量设置区域目标值（区域管理页用）
  locationBasicGoalAutoBatch: '/dms/location/basicGoal/autoBatch', // [POST]{enable}启用/禁用目标值自动设置
  // 企业认证
  companyAuthAuthSubmitAgent: '/crms/crm/companyAuth/approve/agent', // [POST] 授权书认证提交
  companyAuthAuthSubmitLegal: '/crms/crm/companyAuth/authSubmit/legal', // [POST] 法人认证提交
  companyAuthAuthSubmitPay: '/crms/crm/companyAuth/authSubmit/pay', // [POST] 企业打款认证提交
  companyAuthAuthSetSeal: '/crms/crm/companyAuth/setSeal', // [POST] 印章生成{id}
  companyAuthSubmitFinish: '/crms/crm/companyAuth/submit/finish', // [POST] 实名认证最后一步提交 {partnerId}
  companyAuthToAuth: '/crms/crm/companyAuth/toAuth', // [GET] 进入企业认证提交时的企业详情{id}
  companyAuthEnterpriseCorporateAccountAudit: '/crms/crm/companyAuth/enterprise/corporateAccountAudit', // [POST] 企业打款发起
  companyAuthEnterpriseCorporateAccountAuditRemainingTimes: '/crms/crm/companyAuth/enterprise/corporateAccountAudit/remainingTimes', // [POST] 剩余企业打款次数，验证次数{partnerId}
  companyAuthApprovalNoAgent: '/crms/crm/companyAuth/approval/no/agent', // [POST]授权书审批-拒绝
  companyAuthApprovalYesAgent: '/crms/crm/companyAuth/approval/yes/agent', // [POST]授权书审批-通过

  faultInfoPage: '/dms/fault/info/page', // [GET] 故障列表-未处理
  faultHistPage: '/dms/fault/hist/page', // [GET] 故障列表-已处理
  faultClearFault: '/dms/fault/clearFault', // {faultInfoId} [POST] 故障手动清除
  faultHistExport: '/dms/fault/hist/export', // [GET] 导出已处理故障列表
  faultInfoExport: '/dms/fault/info/export', // [GET] 导出未处理故障列表
  faultClearFaultBatch: '/dms/fault/clearFault/batch', // {[faultInfoId]} [POST] 故障手动清除 - 批量操作
  faultBatteryAbnormalPage: '/dms/batteryAbnormal/page',
  faultBatteryAbnormalExport: '/dms/batteryAbnormal/export',

  // 保养项目管理
  UpkeepAdd: '/asm/upkeep/item/add', // 保养项目新增
  UpkeepDelete: '/asm/upkeep/item/delete', // 保养项目删除
  UpkeepPage: '/asm/upkeep/item/page', // 保养分页列表
  UpkeepInfo: '/asm/upkeep/item/info', // 保养项目详情
  UpkeepUpdate: '/asm/upkeep/item/update', // 保养更新
  UpkeepView: '/asm/upkeep/item/view', // 保养查看
  UpkeepCycleSave: '/asm/upkeepCycle/save', // 保养周期保存
  // 售后区域
  ServiceAreaAdd: '/asm/serviceArea/add', // 添加售后区域
  ServiceAreaDelete: '/asm/serviceArea/delete', // 删除售后区域
  ServiceAreaPage: '/asm/serviceArea/page', // 售后区域分页列表
  // 售后负责人设置
  TechnicianPage: '/asm/technician/page', // 售后负责人
  TechnicianSave: '/asm/technician/setup', // 售后负责人
  TechnicianBatchSave: '/asm/technician/setup/batch', // 批量售后负责人
  TechnicianExport: '/asm/technician/export', // 负责人导出
  // 总部售后设置
  UserAreaServicePage: '/asm/userArea/service/page', // 分页列表
  UserAreaBatchSave: '/asm/userArea/batch/save', // 添加售后
  UserAreaBatchDelete: '/asm/userArea/batch/delete', // 删除总部售后
  userAreaUnAssScPage: '/crms/crm/partner/userArea/unAssSc/page', // 查售后公司
  userAreaBatchUpdateAutoGenWorkOrder: '/asm/userArea/batch/updateAutoGenWorkOrder', // 批量更新客服是否自动接单

  // 零件信息管理
  PartAdd: '/asm/part/add', // 零件信息新增
  PartDelete: '/asm/part/delete', // 零件信息删除
  PartPage: '/asm/part/page', // 零件信息分页
  PartUpate: '/asm/part/update', // 修改零件信息
  PartInfo: '/asm/part/info', // 查看零件信息

  partCheckDataPage: '/asm/part/checkData/page', // 获取excel检查数据列表
  partDownloadTemplate: '/asm/part/downloadTemplate', // 获取零件导入模板
  partExcel: '/asm/part/excel', // 上传excel
  partExport: '/asm/part/export', // 导出零件
  partExportFailData: '/asm/part/exportFailData', // 导出检测异常数据
  partImport: '/asm/part/import', // {flag}// 确认导入

  partPreAssociatePage: '/asm/part/preAssociatePage', // 可关联零件列表
  partSetTheoryUseTime: '/asm/part/setTheoryUseTime', // 设置理论寿命
  // 零件寿命
  PartLifePage: '/asm/part/life/page', // 零件寿命
  PartLifeSet: '/asm/part/setTheoryUseTime', // 修改零件信息
  PartReplacePage: '/asm/partReplace/pageForDevice', // 零件更换记录
  PartReplace: '/asm/partReplace/page', // 零件更换明细
  PartReplaceExport: '/asm/partReplace/export', // 零件更换导出
  PartAveLifePage: '/asm/part/useTime/page', // 零件平均寿命
  PartAveLifeExport: '/asm/part/useTime/export', // 零件平均寿命导出

  PartMajorChangePage: '/asm/majorPart/changeUnregister/page', // 重大零件更换未登记分页列表
  PartMajorChangeCreate: '/asm/majorPart/changeUnregister/createWorkOrder', // 添加工单
  PartMajorChangeInvalid: '/asm/majorPart/changeUnregister/markAsInvalid', // 标记无效

  PartMajorApprovalPage: '/asm//majorPart/approvalPage', // 重大零件更换审批列表
  PartMajorApprovalExport: '/asm/majorPart/exportApproval', // 重大零件更换审批导出
  PartMajorApproval: '/asm//majorPart/approval', // 重大零件更换审批提交
  PartMajorBind: '/asm/majorPart/associate', // 新零件与设备关联
  PartMajorReplace: '/asm//majorPart/replaceApply', // 重大零件更换申请
  PartMajorReplacePage: '/asm/majorPart/replacePage', // 重大零件更换明细列表
  PartMajorExport: '/asm/majorPart/export', // 重大零件更换导出
  PartMajorReplaceExport: '/asm/majorPart/changeUnregister/export', // 重大零件未登记导出

  // 零件位置
  partInfoSelectList: '/asm/part/info/selectList', // [GET] 零件信息分页列表(下拉选)
  partLocationPageList: '/asm/part/location/page', // [GET] 获取设备零件位置分页列表
  partLocationAdd: '/asm/part/location/add', // [POST]新增零件位置
  partLocationUpdate: '/asm/part/location/update', // [PUT]修改零件位置
  partLocationDelete: '/asm/part/location/delete', // [DELETE] 删除
  partlocationPartPage: '/asm/part/location/part/list', // [GET] 指定产品已配置的零件列表
  partLocationSetup: '/asm/part/location/setup', // [POST] 零件位置设置
  // 零件更换没登记
  partUnregisterPage: '/dms/part/unregister/page', // [GET] 分页列表
  partUnregisterInvalidTag: '/dms/part/unregister/invalidTag', // [POST]标记无效{partUnregisterId}
  partUnregisterExport: '/dms/part/unregister/export', // [GET] 导出
  // 工单
  WorkOrder: '/asm/workOrder/page', // 获取工单(故障)分页列表
  WorkOrderPart: '/asm/workOrder/part/page', // 零件分页列表
  WorkOrderResume: '/asm/work/order/device/resume', // 设备履历信息
  WorkOrderAttach: '/base/attach/biz', // 附件列表
  WorkOrderInfo: '/asm/work/order/info', // 工单详情
  WorkOrderReplace: '/asm/workOrder/replace/method', // 更换零件赔偿方式
  WorkOrderLog: '/asm/work/order/log', // 查看工单日志
  WorkOrderWaitPage: '/asm/workOrder/waitAssign/page', // 待分配工单列表
  WorkOrderWaitExport: '/asm/workOrder/waitAssign/export', // 待分配工单导出
  WorkOrderWaitPerson: '/asm/workOrder/waitAssign/assign', // 待分配工单设置售后负责人
  WorkOrderTotalTechnicianList: '/asm/workOrder/totalTechnicianList', // [GET] 转派工单-选择售后 和统计列表同一个接口
  WorkOrderPageDeviceWorkOrdersOffline: '/asm/workOrder/page/deviceWorkOrders/offline', // [GET] {bodyNum} 设备-不在线服务记录
  workOrderPartIsExistPartReplace: '/asm/workOrderPart/isExistPartReplace', // [GET] 是否存在零件更换

  workOrderPageFinishExport: '/asm/workOrder/page/finish/export', // [POST] 个人工单管理-已解决-导出
  workOrderPageWaitExport: '/asm/workOrder/page/wait/export', // [POST] 个人工单管理-待接单-导出
  workOrderPageIngExport: '/asm/workOrder/page/ing/export', // [POST] 个人工单管理-解决中-导出
  workOrderPageMyOrgWaitExport: '/asm/workOrder/page/myorg/wait/export', // [POST] 工单管理-所有待接单（组织）-导出
  workOrderPageOrgFinishExport: '/asm/workOrder/page/org/finish/export', // [POST] 工单管理-已解决（组织）-导出
  workOrderPageOrgIngExport: '/asm/workOrder/page/org/ing/export', // [POST] 工单管理-解决中（组织）-导出
  WorkOrderDetail: '/asm/workOrder/info', // [GET] {workOrderId} 工单详情
  WorkOrderPageMyorgWait: '/asm/workOrder/page/myorg/wait', // [GET] 所有待接单
  WorkOrderPageMyselfWait: '/asm/workOrder/page/wait', // [GET] 我的待接单
  WorkOrderPageOrgFinish: '/asm/workOrder/page/org/finish', // [GET] 所有已解决
  WorkOrderPageMyselfFinish: '/asm/workOrder/page/finish', // [GET] 我的已解决
  WorkOrderPageOrgIng: '/asm/workOrder/page/org/ing', // [GEt] 所有解决中
  WorkOrderPageMyselfIng: '/asm/workOrder/page/ing', // [GET] 我的解决中
  WorkOrderPageUnsolved: '/asm/workOrder/page/org/unsolved', // [GET] 组织工单列表（未解决）
  WorkOrderPageUnsolvedExport: '/asm/workOrder/page/org/unsolved/export', // [GET] 组织工单导出（未解决）
  WorkOrderPageMyUnsolved: '/asm/workOrder/page/unsolved', // [GET] 我的工单列表（未解决）
  WorkOrderPageMyUnsolvedExport: '/asm/workOrder/page/unsolved/export', // [GET] 我的工单导出（未解决）


  WorkOrderDeviceInfo: '/asm/workOrderDevice/info', // case工单分页列表（客服）

  // 案例订单 处理记录
  workOrderTechnicianList: '/asm/workOrderTechnician/list', // 列表  售后人员处理工单
  workOrderPartList: '/asm/workOrderPart/list', // 工单零件更换 列表
  ratingDeviceInfo: '/crms/crm/ratingDevice/info', // 设备评级信息
  caseOrderStateList: '/asm/caseOrderState/list', // 列表
  workOrderUpkeepResultComponentList: '/asm/workOrderUpkeepResult/component/list', // 部件保养列表
  workOrderItemList: '/asm/workOrderItem/list', // 列表
  caseOrderItemList: '/asm/caseOrderItem/list', // 案例订单服务项
  caseOrderItemReworkItems: '/asm/caseOrderItem/reworkItems', // [GET] 返工项列表
  workOrderItemReworkList: '/asm/workOrderItem/reworkList', // [GET] {workOrderId} 工单返工项列表
  workOrderItemTemporarilySave: '/asm/workOrderItem/temporarilySave', // [POST] {workOrderId} 暂存返工工单
  workOrderItemFinishRework: '/asm/workOrderItem/finishRework', // [POST] {workOrderId} 完成返工
  workOrderItemClearCheck: '/asm/workOrderItem/clearCheck', // [POST] workOrderItemId 取消勾选删除
  workOrderTechnicianInfo: '/asm/workOrderTechnician/info', // [GET] 售后人员详情（最终处理人）
  //  售后工程师管理
  userAfterSaleRolePage: '/asm/userArea/afterSaleRole/page', // 售后工程师
  userAreaSetup: '/asm/userArea/userArea/setup', // 设置售后区域
  userAreaSelectList: '/asm/userArea/selectList', // 指定售后公司的售后工程师选择列表
  // 工单零件更换
  workOrderPartPage: '/asm/workOrderPart/page', //  [GET]零件更换分页列表
  workOrderPartExport: '/asm/workOrderPart/export', //  [GET]零件更换明细导出
  workOrderPartDetailPage: '/asm/workOrderPart/detail/page', //  [GET]零件更换明细分页列表
  workOrderPartListForDevice: '/asm/workOrderPart/listForDevice', //  [GET]设备零件更换明细分页列表
  workOrderPartPaymentOrgChange: '/asm/workOrderPart/paymentOrg/change', // [POST]更换付款方
  workOrderPartPartReplace: '/asm/workOrderPart/partReplace', // [POST] 更换零件
  workOrderPartDelete: '/asm/workOrderPart/delete', // [POST] {orderPartId} 删除零件更换记录

  // 零件库存
  partStockAdd: '/dms/partStock/add', // [POST]添加零件
  partStockCheckDataPage: '/dms/partStock/checkData/page', // [GET]获取excel检查数据列表
  partStockDelete: '/dms/partStock/delete', // [POST]删除零件/{stockFactoryId}
  partStockDownloadTemplate: '/dms/partStock/downloadTemplate', // [GET] 获取零件导入模板
  partStockExcel: '/dms/partStock/excel', // [POST] 上传excel
  partStockExportFailData: '/dms/partStock/exportFailData', // [GET] 导出检测异常数据
  partStockImport: '/dms/partStock/import', // [POST] 确认导入/{flag}
  partStockPage: '/dms/partStock/page', // [GET] 获取零件分页列表
  partStockUpdate: '/dms/partStock/update', // [POST]编辑零件
  partList: '/asm/part/list', // [GET] 零件列表
  stockServiceConfig: '/dms/stock/serviceConfig', // 服务配置标志查询

  PartnerService: '/crms/crm/partner/allService', // 获取总部售后公司
  partnerBankcardList: '/crms/crm/crmPartnerBankcard/list', // [GET]获取银行卡列表
  partnerBankcardAdd: '/crms/crm/crmPartnerBankcard/add', // [POST]新增银行卡
  partnerBankcardDefualt: '/crms/crm/crmPartnerBankcard/defualt', // [POST]设置默认{id}
  partnerBankcardDelete: '/crms/crm/crmPartnerBankcard/delete', // [DELETE]删除银行卡{id}
  PartnerBankcardDisableOrEnable: '/crms/crm/crmPartnerBankcard/disableOrEnable', // 禁用启用银行卡{id}
  partnerBankcardUpdate: '/crms/crm/crmPartnerBankcard/update', // [PUT]修改银行卡
  PartnerBankcardListByOrgId: '/crms/crm/crmPartnerBankcard/listByOrgId', // [GET]获取银行卡列表 合作伙伴
  PartnerBankcardAddByOrgId: '/crms/crm/crmPartnerBankcard/addByOrgId', // [POST]添加银行卡列表 合作伙伴
  crmCrmPartnerBankcardPage: '/crms/crm/crmPartnerBankcard/page', // 登录人银行卡列表分页

  // 上上签
  bestsginBusinessLicenseOcr: '/crms/crm/bestsgin/businessLicenseOcr', // [POST]营业执照OCR识别
  crmBankInfoSelectIce: '/crms/crm/crmBankInfo/select/ice', // [GET] 银行卡下拉-ICE
  identity3SendMobile: '/crms/crm/bestsgin/identity3SendMoblie', // [POST] 获取短信验证码
  businessLicenseOcr: '/crms/crm/aliYun/businessLicenseOcr', // [POST]新阿里云营业执照OCR识别

  fmsContractServiceReceivable: '/fms/fmsContractBill/page4ServiceReceivable', // [GET]售后公司应收 分页及查询
  fmsContractBillServicePay: '/fms/fmsContractBill/page4ServicePay', // [GET]售后公司应付 分页及查询
  fmsTradeRegister4bill: '/fms/fmsTrade/register4bill', // [POST]应收应付账单-收款登记
  fmsTradeTradeList: '/fms/fmsTrade/tradeList', // [GET]售后公司应收{tradeOrderId}
  fmsTradeConfirm: '/fms/fmsTrade/confirm', // {billId}

  fmsApprovalwithdrawBillCostByService: '/fms/fmsContractBill/withdrawBillCostByService', // [POST]售后公司撤回收款申请-账单收款

  fmsContractBillPage4FactoryReceivable: '/fms/fmsContractBill/page4FactoryReceivable', // [GET] 总部应收 分页及查询
  fmsApprovalApprove4overdueDays: '/fms/fmsApproval/approve4overdueDays', // [POST]账单-延期收款申请
  fmsApprovalApprove4BackBillCost: '/fms/fmsApproval/approve4BackBillCost', // [POST]总部撤回收款申请-账单收款
  fmsContractBillInfo: '/fms/fmsTrade/tradeList', // [GET] {tradeOrderId}查询总部应收详情

  fmsApprovalApprove4updateBankTime: '/fms/fmsApproval/approve4updateBankTime', // [POST]修改银行时间审批发起
  fmsApprovalPage: '/fms/fmsApproval/page', // [GET] 审批分页  approvalType 1-银行收款、2-撤销账单收款、3-延期收款
  fmsApprovalInfoBill: '/fms/fmsApproval/info/bill', // [GET] {id} 查询审批详情
  fmsApprovalApplyNo: '/fms/fmsApproval/applyNo', // [POST]审批拒绝
  fmsApprovalApplyYes: '/fms/fmsApproval/applyYes', // [POST]审批通过

  fmsContractBillPage4ServicePay: '/fms/fmsContractBill/page4ServicePay', // [GET] 售后公司应付 分页及查询
  fmsTradeEdit4bill: '/fms/fmsTrade/edit4bill', // [POST] 应收应付账单-收款编辑

  dmsStockCostDetailPage4Factory: '/crms/crm/dmsStockCostDetail/page4Factory', // [GET]库存应收服务费
  dmsStockCostDetailPage4Service: '/crms/crm/dmsStockCostDetail/page4Service', // [GET]库存应付服务费
  fmsTrade4StockRegister: '/fms/fmsTrade4Stock/register', // 库存服务费登记
  fmsTrade4StockTradeList: '/fms/fmsTrade4Stock/tradeList', // 收款详情
  fmsTrade4StockConfirm: '/fms/fmsTrade4Stock/confirm', // /{billId}收款确认-账单ID
  fmsApprovalApprove4BackStockCost: '/fms/fmsApproval/approve4BackStockCost', // 库存撤销
  fmsContractBillWithdrawStockCostByService: '/fms/fmsContractBill/withdrawStockCostByService', // 撤销付款{tradeOrderId}
  fmsTrade4StockEidt: '/fms/fmsTrade4Stock/edit', // [POST]库存管理费-收款修改

  fmsEditRemark: '/fms/invoice/editRemark', // 编辑发票备注

  partnerInvoiceSelect: 'crm/partner/invoiceSelect', // [GET] 获取发票抬头信息下拉
  invoiceNormalInvoicing: '/fms/invoice/normalInvoicing', // [POST] 开票
  invoicePage: '/fms/invoice/page', // [GET]获取开票分页
  invoiceInvoiceBillList: '/fms/invoice/invoiceBillList', // {invoiceId}查看明细
  invoicefmsContractBillRecordsReceivables: 'fms/fmsContractBill/records/receivables', // [GET]  正常开票收款记录
  invoiceSelectPayable: 'fms/fmsContractBill/select/payable', // [GET]   付款公司 下拉

  invoiceInfoNormal: '/fms/invoice/info/normal', // [GET]{invoiceId} 获取正常开票详情
  invoiceInfoRed: '/fms/invoice/info/red', // [GET]{invoiceId} 获取冲红开票详情
  invoiceBatchCheck: '/fms/invoice/batchCheck', // [POST] 批量开票导入-验证
  invoiceBatchInvoice: '/fms/invoice/batchInvoice', // [POST] 提交批量开票
  invoiceExportBatchInvoce: '/fms/invoice/exportBatchInvoce', // [POST]批量开票导出

  // 发票相关-标记未开票-发票提交-发票详情-发票列表
  invoiceMark: '/fms/invoice/mark', // [POST] 账款标记待开票
  invoiceSendEmail: '/fms/invoice/sendEmail', // [POST] 发送邮件

  contractPreInvoiceContracts: '/crms/crm/contract/preInvoice/contracts', // [GET]提前开票 -第一步选择合同列表

  contractPreInvoiceNostartDevices: '/crms/crm/contract/preInvoice/nostartDevices', // [GET]查询合同未起租设备
  fmsInvoicePreInvoiceStartDevices: '/fms/invoice/preInvoice/startDevices', // [GET]查询合同已起租未交易设备
  fmsApprovalApprove4preInvoice: '/fms/fmsApproval/approve4preInvoice', // [POST]提前开票审批发起
  fmsApprovalApprove4red: '/fms/fmsApproval/approve4red', // [POST]冲红提交
  fmsinvoiceWithdrawRed: '/fms/invoice/withdrawRed', // [POST] {invoiceId} 撤销冲红
  downloadBatchInvoice: '/dms/download/batchInvoice', // [GET]批量开票-下载导入模板
  partnerSelectCustomer: '/crms/crm/partner/select/customer', // [GET]乙方客户下拉
  partnerSelectLargecustomer: '/crms/crm/partner/select/largecustomer', // [GET]集团客户下拉
  partnerSelectService: '/crms/crm/partner/select/service', // [GET]甲方授权代表下拉
  partnerFactoryServiceList: '/crms/crm/partner/factory/serviceList', // [GET]获取当前登录人所属总部下所有的售后公司 售后公司下拉

  // 开票审批
  invoicePageApproval: '/fms/invoice/pageApproval', // [GET]开票管理-提前开票、冲红审批分页
  invoiceInfoPre: '/fms/invoice/info/pre', // [GET] {invoiceId}提前开票详情
  invoiceInfoGoRed: '/fms/invoice/info/goRed', // [GET]{invoiceId}发起冲红审批
  invoicePageNoStart: '/fms/invoice/pageNoStart', // [GET] 合同开票未起租-分页

  // 工单管理 /asm//work/order/
  WordOrderExport: '/asm/workOrder/export', // [GET] 工单导出
  WordOrderPageList: '/asm/workOrder/page', // [GET] 工单分页列表
  workOrderOptUpdateServiceMethod: '/asm/workOrder/opt/updateOnsiteArrived', // (张鹏) [POST] {orderTechnicianId} 修改为现场解决方式

  trackList: '/asm/track/list', // [GET] {workOrderId} 路径轨迹

  // IOT物模型管理
  TslHisVersion: '/dms/tsl/hisVersion', // [GET] 产品物模型历史版本列表

  TslDeviceParamList: '/dms/tsl/device/param/list', // 参数查询
  TslDeviceParamGroupTree: '/dms/tsl/device/paramGroup/Tree', // 参数分组树查询

  // 合同发货记录表
  LogisticsDevicePage: '/crms/lms/logistics/device/page', // 获取指定物流单下的设备列表
  LogisticsPage: '/crms/lms/logistics/page', // 获取合同物流 Logistics
  LogisticsSms: '/crms/lms/logistics/sms', // {customShipmentNum} 发送短信验证码
  LogisticsUpdate: '/crms/lms/logistics/update', // 更新物流信息

  // lms-调拨单发货
  transferOrderLogisticsPage: '/crms/lms/transferOrder/logistics/page', // [GET] 获取合同物流记录
  transferOrderOutPage: '/crms/lms/transferOrder/outPage', // [GET] 合同订单发货记录
  transferOrderLogisticsDevicePage: '/crms/lms/transferOrder/logistics/device/page', // [GET] 获取指定物流单下的设备列表

  // 通讯板与电池 Modem测试
  feignModemBatteryOnline: '/dms/feign/modemBattery/online', // [POST] {modemSn}/{isOnline}//通讯板上线下线
  modemBatteryComponentEventPage: '/dms/modemBattery/component/event/page', // [GET] 部件详情-事件记录
  modemBatteryComponentOnlineEventPage: '/dms/modemBattery/component/onlineEvent/page', // 部件详情-上下线事件记录
  modemBatteryComponentList: '/dms/modemBattery/component/list', // [GET]部件列表
  modemBatteryExport: '/dms/modemBattery/export', // [GET]设备测试导出
  modemBatteryInfo: '/dms/modemBattery/info', // [GET]通讯板与电池详情
  modemBatteryPage: '/dms/modemBattery/page', // [GET]通讯板与电池分页（测试报告分页）
  modemBatteryParamlist: '/dms/modemBattery/param/list', // [GET]配置参数查询
  modemBatteryParamGrouplist: '/dms/modemBattery/paramGroup/list', // [GET] 配置参数分类查询
  modemBatteryParamItemHisList: '/dms/modemBattery/paramItem/hisList', // [GET] 配置项历史查询
  modemBatteryParamItemlastBill: '/dms/modemBattery/paramItem/lastBill', // [GET] 最后一次下发账单的配置
  modemBatteryParamItemList: '/dms/modemBattery/paramItem/list', // [GET]配置项查询
  modemBatteryParamItemControl: '/dms/modemBattery/paramItem/list2', // [GET] 配置项查询（控制中心）
  modemBatteryParamItemSave: '/dms/modemBattery/paramItem/save', // [POST] 配置项保存
  modemBatteryParamItemSaveBill: '/dms/modemBattery/paramItem/saveBill', // [POST] 账单配置保存
  modemBatteryRefresh: '/dms/modemBattery/refresh', // [POST] {modemSn}刷新
  commandTaskModemOfflineTask: '/dms/command/task/modem/offlineTask', // 获取设备部件离线任务
  modemBatteryScrapped: '/dms/modemBattery/scrapped', // 报废接口（电池管理）
  modemBatteryUpdate: '/dms/modemBattery/update', // 更新通讯板与电池
  modemBatteryInit: '/dms/modemBattery/init', // [POST] {modemBatteryId}通讯板初始化
  // 通讯板部件详情
  modemBatteryComponentBase: '/dms/modemBattery/component/base', // 部件详情-基础信息
  modemBatteryComponentBaseHistPage: '/dms/modemBattery/component/base/histPage', // 部件详情-历史基础信息
  // modemBatteryComponentEventPage: '/dms/modemBattery/component/event/page', // 部件详情-事件记录
  modemBatteryComponentStatus: '/dms/modemBattery/component/status', // 部件详情-实时状态
  modemBatteryComponentStatusHistPage: '/dms/modemBattery/component/status/histPage', // 部件详情-历史状态
  modemBatteryComponentVoltage: '/dms/modemBattery/component/voltage', // 部件详情-电压
  modemBatteryTabShow: '/dms/modemBattery/tabShow', // tab页显示控制
  modemBatteryComponentEventExport: '/dms/modemBattery/component/event/export', // 部件详情-事件记录导出
  modemBatteryComponentOnlineEventExport: '/dms/modemBattery/component/onlineEvent/export', // 部件详情-事件记录导出
  // 设备测试报告
  DeviceTestReportAdd: '/dms/deviceTestReport/add', // 添加测试报告(通过，不通过)
  DeviceTestReportGenerate: '/dms/deviceTestReport/generate', // 生成测试报告
  DeviceTestReportInfo: '/dms/deviceTestReport/info', // [GET] 测试报告详情{testReportId}
  DeviceTestReportList: '/dms/deviceTestReport/list', // [GET]查看测试报告列表
  DeviceTestReportStockIn: '/dms/deviceTestReport/stock/in', // 设备测试入库

  // 区域管理
  NationRegionAdd: '/base/nationRegion/add', // 新增区域
  NationRegionDelete: '/base/nationRegion/delete', // 删除区域
  NationRegionInfo: '/base/nationRegion/info', // 区域详情
  NationRegionTree: '/base/nationRegion/tree', // 区域树
  NationRegionUpdate: '/base/nationRegion/update', // 更新区域

  // 设备报废管理 /dms/scrapApply/
  ScrapApplyApply: '/dms/deviceScrap/apply', // [POST]报废申请
  ScrapApplyApplyDetail: '/dms/deviceScrap/applyDetail', // [GET] {deviceId} 报废申请详情查看
  ScrapApplyApplyExport: '/dms/deviceScrap/applyExport', // [GET]设备报废申请导出
  ScrapApplyApproval: '/dms/deviceScrap/approval', // [POST]报废审批
  ScrapApplyApprovalExport: '/dms/deviceScrap/approvalExport', // [GET]设备报废审批导出
  ScrapApplyApprovalPage: '/dms/deviceScrap/approvalPage', // [GET]设备报废审批分页
  ScrapApplyCancelApply: '/dms/deviceScrap/applyCancel/', // [PUT] {scrapApplyId} 撤销申请
  ScrapApplyPage: '/dms/deviceScrap/applyPage', // [GET]设备报废管理分页

  // tms 培训教程
  tmsProductList: '/tms/product/list', // [GET]获取产品列表
  tmsProductAdd: '/tms/product/add', // [POST]添加产品
  tmsProductDelete: '/tms/product/delete', // [POST]{productId}删除产品
  tmsProductInfo: '/tms/product/info', // [GET] 获取产品详情
  tmsProductUpdate: '/tms/product/update', // [POST]修改产品
  tmsProductUpdateState: '/tms/product/update/state', // [POST]修改产品状态

  // 设备履历表
  DeviceResumeFaultPage: '/asm/device/resume/fault/page', // 设备维修记录
  DeviceResumePartReplacePage: '/asm/device/resume/partReplace/page', // 设备零件更换记录
  DeviceResumeUpkeepPage: '/asm/device/resume/upkeep/page', // 设备保养记录
  DeviceResumeWorkInfo: '/asm/device/resume/workInfo', // 设备运行数据

  // 设备详情
  DeviceResumeComponentBase: '/dms/device/resume/component/base', // 部件详情-基础信息
  DeviceResumeComponentList: '/dms/device/resume/component/list', // 部件列表
  DeviceResumeComponentStatus: '/dms/device/resume/component/status', // 部件详情-实时状态
  DeviceResumeComponentEventPage: '/dms/device/resume/component/event/page', // 部件详情-事件记录
  DeviceResumeComponentOnlinePage: '/dms/device/resume/component/online/page', // 部件详情-在线事件记录
  DeviceResumeComponentEventExport: '/dms/device/resume/component/event/export', // 部件详情-事件记录导出
  DeviceResumeComponentOnlineEventExport: '/dms/device/resume/component/onlineEvent/export', // 部件详情-事件记录导出
  DeviceResumeComponentStatusHistPage: '/dms/device/resume/component/status/histPage', // 部件详情-历史状态
  DeviceResumeComponentStatusHistExport: '/dms//device/resume/component/status/hist/export', // 部件详情-历史状态-导出
  DeviceResumeComponentVoltage: '/dms/device/resume/component/voltage', // 部件详情-电压
  DeviceResumeComponentNewFault: '/dms/device/resume/component/newFault', // 部件详情-最新的故障
  DeviceResumeRefresh: '/dms/device/resume/refresh', // 刷新状态
  DeviceResumeComponentFaultPage: '/dms/device/resume/component/fault/page', // 部件详情-故障记录
  DeviceResumeComponentBaseHistPage: '/dms/device/resume/component/base/histPage', // 部件详情-历史基础信息
  DeviceResumeComponentBaseHistExport: '/dms/device/resume/component/base/hist/export', // 部件详情-历史基础信息-导出
  DeviceResumeTabShow: '/dms/device/resume/tabShow', // tab页显示控制
  DeviceResumeBizInfo: '/dms/device/resume/bizInfo', // [GET]业务基本信息
  rmsOrderDeviceInfo: '/crms/rms/orderDevice/info', // [GET]合同/订单设备列表
  DeviceResumeWorkOrderPage: '/asm/device/resume/workOrder/page', // [GET]设备-维修(保养)记录
  DeviceResumeLogPage: '/dms/device/resume/log/page', // [GET]设备日志
  DeviceResumeLogExport: '/dms/device/resume/log/export', // [GET]设备日志导出
  DeviceResumeComponentPage: '/dms/device/resume/component/page', // [GET]设备详情-机器履历
  DeviceResumeComponentExport: '/dms/device/resume/component/export', // [GET]设备详情-机器履历导出
  // 设备业务类型管理
  DeviceBizTypeAdd: '/dms/device/bizType/add', // 新增业务类型
  DeviceBizTypeInfo: '/dms/device/bizType/info', // 业务类型详情
  DeviceBizTypePage: '/dms/device/bizType/page', // 业务类型分页列表
  DeviceBizTypeUpdate: '/dms/device/bizType/update', // 编辑业务类型
  DeviceBizTypeProductList: '/dms/device/bizType/product/list', // 未配置业务类型的产品列表
  DeviceBizTypeDelete: '/dms/device/bizType/delete', // 删除

  // 产品协议发布
  ProtocolPublishList: '/iot/protocolPublish/list', // /protocolPublish/list/{protocolId} 发布记录
  ProtocolPublishPublish: '/iot/protocolPublish/publish', // /protocolPublish/publish/{protocolId}/{version} 版本发布
  ProtocolPublishPublishDelete: '/iot/protocolPublish/publish/delete', // /protocolPublish/publish/delete/{publishId}  版本删除
  ProtocolPublishRePublish: '/iot/protocolPublish/rePublish', // /protocolPublish/rePublish/{publishId}  版本重新发布
  ProtocolPublishTopicPage: '/iot/protocolPublish/topic/page', // 发布记录-分页
  ProtocolPublishTopicList: '/iot/protocolPublish/topic/list', // [GET]topic发布记录-列表
  protocolPublishTimPublish: '/iot/protocolPublish/timPublish', // [POST] {protocolId} TIM版本发布

  // 衍生协议-结构(组件)管理
  DerivedComponentRelationList: '/dms/derivedComponent/relationList', // [GET] 衍生协议部件列表 分类-部件
  DerivedComponentFromStandardPageComponent: '/dms/derivedComponent/fromStandard/page/component', // [GET] 从标准协议复制部件-组件分页
  DerivedComponentRelationSave: '/dms/derivedComponent/relationSave', // [POST] {protocolCode} 关联部件-保存
  DerivedComponentDelete: '/dms/derivedComponent/delete', // [POST] {protocolCode} 批量删除部件

  // 标准、定制协议结构(组件)管理
  ComponentList: '/dms/component/list', // [GET] 所有部件列表 分类-部件
  ComponentListType: '/dms/component/list/type', // [GET] {protocolCode}  部件分类列表
  ComponentDelete: '/dms/component/delete', // [POST] 删除部件
  ComponentSaveType: '/dms/component/save/type', // [POST] 部件分类保存
  ComponentSave: '/dms/component/save', // [POST] 保存部件
  ComponentIconList: '/dms/component/iconList', // [GET] 部件图标附件id集合
  ComponentDbSave: '/dms/component/db/save', // [POST] {componentId} 设置表关系-批量保存
  ComponentDbList: '/dms/component/db/list', // [GET] componentId 设置表关系-表关系列表
  ComponentCombineSelect: '/dms/component/combineSelect', // [GET] {protocolCode} 合成部件下拉获取数据
  ComponentCopyListProtocol: '/dms/component/copy/list/protocol', // [GET] 复制部件-协议列表
  ComponentCopyPageComponent: '/dms/component/copy/page/component', // [GET] 复制部件-组件分页
  ComponentCopyComponentSave: '/dms/component/copy/component/save', // [POST] {protocolCode} 复制部件-批量保存
  ComponentBatchDelete: '/dms/component/batchDelete', // [POST] 批量删除部件
  ComponentPublish: '/dms/component/publish', // [POST] 发布结构
  ComponentReplaceComponentList: '/dms/component/replace/componentList', // 更换需登记的部件列表
  tmsProductTrainingAdd: '/tms/product/training/add', // [POST] 添加产品教程
  tmsProductTrainingDelete: '/tms/product/training/delete', // [POST]  {trainingId} 删除视频教程
  tmsProductTrainingInfo: '/tms/product/training/info', // [GET]教程产品详情
  tmsProductTrainingList: '/tms/product/training/list', // [GET]产品教程列表
  tmsProductTrainingNodeDelete: '/tms/product/training/node/delete', // [POST] {nodeId}删除教程节点
  tmsProductTrainingUpdate: '/tms/product/training/update', // [POST]  修改产品教程
  tmsProductTrainingUpdateState: '/tms/product/training/update/state', // [POST]修改产品教程状态

  // 电子合同管理-发件箱-待签署
  econtractCancel: '/crms/crm/econtract/cancel', // [POST] {econtractId} 撤销电子合同
  econtractPageSender: '/crms/econtract/page/sender', // [GET] 发件箱分页列表
  econtractPageSigner: '/crms/econtract/page/signer', // [GET] 收件箱

  // SIM卡
  simDataExport: '/dms/simData/export',
  simDataAddCountsByMonth: '/dms/sim/addCountsByMonth', // [GET] {year} 按年，返回每个月的新增数量
  simdDataLogoutBatch: '/dms/simData/logout/batch', // [POST] 批量注销
  simDataPage: '/dms/sim/page', // [GET] 获取DmsSimData分页列表
  simDataTotalActivateCounts: '/dms/sim/totalActivateCounts', // [GET] 统计激活，未激活，作废数量
  simDataAddBatch: '/dms/sim/add/batch', // 批量新增sim
  simDataActive: '/dms/sim/active', // [POST] {simId} 激活
  simDataLogout: '/dms/sim/logout', // [POST] {simId} 注销
  simDataTerminated: '/dms/sim/terminated', // [POST] {simId} 停用
  simDataImport: '/dms/sim/import', // [POST] 导入流水-上传文件
  simDataDownloadTemplate: '/dms/sim/downloadTemplate', // [GET] 导入sim-下载导入模板
  simDataImportFailPage: '/dms/sim/importFail/page', // [GET] {batchNum} SIM卡导入-分页（失败）
  simDataImportSuccessPage: '/dms/sim/importSuccess/page', // [GET] {batchNum} SIM卡导入-分页（成功）
  simDataImportSave: '/dms/sim/import/save', // [POST] {batchNum} excel导入数据保存
  simDataExportFail: '/dms/sim/exportFail', // [POST] {batchNum} 导出异常数据

  simDataMonthCounts: '/dms/sim/dataMonthCounts', // [GET] {year} SIM卡-月使用数据统计
  simExport: '/dms/sim/export', // [GET] SIM卡-导出
  simPage: '/dms/sim/page', // [GET] SIM卡-分页
  simTotalActivateCounts: '/dms/sim/totalActivateCounts', // [GET] SIM卡-状态统计
  simStateBatchUpdate: '/dms/sim/state/batch/update', // [POST] 批量更新
  simStateDownloadTemplate: '/dms/sim/state/downloadTemplate', // [GET] SIM卡状态导入-下载模板
  simStateExportFail: '/dms/sim/state/exportFail', // [GET] {batchNum} SIM卡状态导入-失败页导出
  simStateImport: '/dms/sim/state/import', // [POST] SIM卡状态导入-上传文件
  simStateImportSave: '/dms/sim/state/import/save', // [POST] {batchNum} SIM卡状态导入-保存
  simStateImportFailPage: '/dms/sim/state/importFail/page', // [GET] {batchNum} SIM卡状态导入-失败页
  simStateImportSuccessPage: '/dms/sim/state/importSuccess/page', // [GET] {batchNum} SIM卡状态导入-成功页
  simListByIds: '/dms/sim/listByIds', // [GET] SIM卡-列表
  simLogout: '/dms/sim/logout', // [POST] {simId} SIM卡-注销
  simTerminated: '/dms/sim/terminated', // [POST] {simId} SIM卡-停用
  simActive: '/dms/sim/active', // [POST] {simId} SIM卡-激活
  simDelete: '/dms/sim/delete', // [POST] {simId} SIM卡-删除
  simStatePage: '/dms/sim/state/page', // [GET]  SIM卡状态-分页
  simDataMonthPage: '/dms/sim/dataMonth/page', // [GET] SIM卡月使用-分页
  simDataMonthExport: '/dms/sim/dataMonth/export', // [GET] SIM卡月使用-导出
  simIstDataLimitBatchUpdate: '/dms/sim/istDataLimit/batch/update', // [POST] SIM卡流量-批量更新
  simIstDataLimitDownloadTemplate: '/dms/sim/istDataLimit/downloadTemplate', // [GET] SIM卡流量导入-下载模板
  simIstDataLimitExportFail: '/dms/sim/istDataLimit/exportFail', // [GET] {batchNum} SIM卡流量导入-失败页导出
  simIstDataLimitImport: '/dms/sim/istDataLimit/import', // [POST] SIM卡流量导入-上传文件
  simIstDataLimitImportSave: '/dms/sim/istDataLimit/import/save', // [POST] {batchNum} SIM卡流量导入-保存
  simIstDataLimitImportFailPage: '/dms/sim/istDataLimit/importFail/page', // [GET] {batchNum} SIM卡流量导入-失败页
  simIstDataLimitImportSuccessPage: '/dms/sim/istDataLimit/importSuccess/page', // [GET] {batchNum} SIM卡流量导入-成功页
  simIspTotalActivateCounts: '/dms/simIsp/totalActivateCounts', // SIM卡状态统计
  simIspMonthCounts: '/dms/simIsp/monthCounts', // SIM月激活统计
  simIspMonthExport: '/dms/simIsp/monthDetail/export', //  SIM月激活导出

  simRecordBindPage: '/dms/sim/recordBind/page', // [GET] SIM卡绑定记录-分页

  // 审批管理
  workflowInfoApproveType: '/crms/workflowInfo/approveTypes', // {workflowClass} [GET] 工作流类别的审批流级联
  workflowInfoApproveEnableOrDisable: '/crms/workflowInfo/enableOrDisable', // {workflowId} [POST] 启用或禁用
  workflowInfo: '/crms/workflowInfo/info', // {workflowId} [GET] 审批详情
  workflowInfoPage: '/crms/workflowInfo/page', // [GET] 流程分页
  workflowInfoSave: '/crms/workflowInfo/save', // [POST] 新增、修改审批流程

  // 审批流节点新增修改抄送
  apsWorkflowNodeCopySend: '/crms/apsWorkflowNode/copySend', // [POST] 抄送
  apsWorkflowNodeDelete: '/crms/apsWorkflowNode/delete', // {id} [DELETE] 删除节点
  apsWorkflowNodeInfo: '/crms/apsWorkflowNode/info', // {id} [GET] 详情
  apsWorkflowNodeList: '/crms/apsWorkflowNode/list', // {id} [GET] 审批节点信息
  apsWorkflowNodeSave: '/crms/apsWorkflowNode/save', // [post] 保存节点

  // crm调拨单 后端：阿康
  transferOrderApply: '/crms/crm/transferOrder/apply', // [POST] 调拨申请
  transferOrderInfo: '/crms/crm/transferOrder/info', // [GET] 调拨申请详情
  transferOrderInvalid: '/crms/crm/transferOrder/invalid', // {orderId} [POST] 作废申请
  transferOrderPage: '/crms/crm/transferOrder/page', // [GET] 调拨申请列表
  transferOrderInOrgList: '/crms/crm/transferOrder/inOrgList', // [GET] 入库方列表
  transferOrderOutOrgList: '/crms/crm/transferOrder/outOrgList', // [GET] 出库方列表
  transferOrderDeliver: '/crms/crm/transferOrder/deliver', // [POST] 发货
  transferOrderPreDeliverList: '/crms/crm/transferOrder/preDeliverList', // [GET] 总部/售后待发货列表
  transferOrderPreReceiveList: '/crms/crm/transferOrder/preReceiveList', // [GET] 售后待收货列表
  transferOrderReceive: '/crms/crm/transferOrder/receive', // [POST] 收货
  transferOrderGoodsList: '/crms/crm/transferOrder/goodsList', // [GET] 调拨申请详情
  transferOrderDevicePage: '/crms/crm/transferOrder/device/page', // [GET] 调拨设备列表
  transferOrderDeviceExport: '/crms/crm/transferOrder/device/export', // [GET] 调拨单设备维度导出
  transferOrderLog: '/crms/crm/transferOrder/log', // [GET] 业务日志列表 (调拨动态)
  transferOrderDelete: '/crms/crm/transferOrder/delete', // [POST] {orderId} 删除调拨申请
  transferOrderPageForDevice: '/crms/crm/transferOrder/pageForDevice', // [GET] 调拨单设备维度列表

  // 统一审批接口
  apsApproveApprovalCancel: '/crms/aps/approve/approvalCancel', // [POST] /{type}/{bizId} 流程-作废（草稿）
  apsApproveApprovalApproveNo: '/crms/aps/approve/approveNo', // [POST] /{type}/{bizId} 流程-审批拒绝
  apsApproveApprovalApproveRevoke: '/crms/aps/approve/approveRevoke', // [POST] /{type}/{bizId} 流程-审批撤回
  apsApproveApprovalApproveStart: '/crms/aps/approve/approveStart', // [POST] /{type}/{bizId} 流程-启动
  apsApproveApprovalAapproveYes: '/crms/aps/approve/approveYes', // [POST] /{type}/{bizId} 流程-审批通过
  apsApproveApprovalInfo: '/crms/aps/approve/approvalInfo', // [GET] /{type}/{bizId} 流程-审批详情
  apsApprovePageApprovedApprove: '/crms/aps/approve/page/approvedApprove', // [GET] 已审批的流程
  apsApprovePageCcApprove: '/crms/aps/approve/page/ccApprove', // [GET] 抄送给我的流程
  apsApprovePageInitiate: '/crms/aps/approve/page/initiate', // [GET] 我发起的流程
  apsApprovePageWaitApprove: '/crms/aps/approve/page/waitApprove', // [GET] 待我审批的流程
  apsApproveGetApproveAuth: '/crms/aps/approve/getApproveAuth', // [POST] 登录用户审批权限-返回：    INVALID 作废  APPROVE 审批  WITHDRAW 撤回
  apsApproveGetApproveAuthFlowNode: '/crms/aps/approve/getApproveAuthFlowNode', // {type}获取登录用户有权限的审批节点
  // 新账单交易-登记确认登记等
  paymentCancelPayment: '/fms/payment/cancelPayment', // {billPaymentCode} [POST] 取消支付订单(取消登记)
  paymentPaymentInfo: '/fms/payment/paymentInfo', // [GET] {billId} 付款详情-通过账单ID
  paymentRegister: '/fms/payment/register', // [POST] 付款登记-提交
  paymentProvisionalSave: '/fms/payment/provisionalSave', // [POST] 付款登记-暂存
  paymentRevoke: '/fms/payment/revoke', // [POST] {billPaymentCode} 打回或拒绝
  billOrderPaymentRelatedBills: '/fms/billOrder/payment/relatedBills', // [GET] 登记收款查询账单及关联赠送账单
  paymentToAddPayablePage: '/fms/payment/toAddPayablePage', // [GET] 账单选择分页列表-付款和申请开票通用
  paymentToAddInvoicePage: '/fms/invoice/toAddInvoicePage', // [GET] 账单选择分页（选择待开票）
  paymentBankFlowBind: '/fms/payment/bankFlow/bind', // [POST] {tradeId} {sellerTradeCode} 银行流水绑定
  paymentBankFlowDelete: '/fms/payment/bankFlow/delete', // [POST] {sellerTradeCode} 登记中银行流水删除
  paymentConfirmPayment: '/fms/payment/confirmPayment', // [POST] {billPaymentCode} 确认收款
  paymentBankFlowList: '/fms/payment/bankFlow/list', // [GET] {billPaymentCode} 支付信息的银行流水列表
  paymentInfoByCode: '/fms/payment/paymentInfoByCode', // {billPaymentCode}付款详情-通过支付编号
  portalTotalTermBalance: '/fms/portal/totalTermBalance', // [GET] portal-租赁余额统计数据
  paymentPaymentInfoById: '/fms/payment/paymentInfoById', // [GET] {billPaymentId} 付款详情
  paymentBatchPaymentDownloadTemplate: '/fms/payment/batchPayment/downloadTemplate', // [GET] 批量登记付款-下载导入模板
  paymentExcelImport: '/fms/payment/excel/import', // [POST] 批量登记付款-上传文件

  // 账单交易-登记确认登记等
  paymentPayablePaymentPage: '/fms/payment/payablePayment/page', // [GET] 付款支付订单
  paymentReceivablePaymentPage: '/fms/payment/receivablePayment/page', // [GET] 收款支付订单
  billPaymentToAddPayablPage: '/fms/billPayment/toAddPayablPage', // [GET] 应付账单选择分页列表
  billPaymentToRegister: '/fms/billPayment/paymentInfo', // [GET] ｛billType｝ 登记初始化
  billOrderPayPage: '/fms/billOrderTerm/payable/page', // 应付租赁列表
  billOrderPayPageMonth: '/fms/billOrderTerm/payable/page/month',
  billOrderTermBillIdMonths: '/fms/billOrderTerm', //  [GET]{billId}/months//月账单列表
  billPaymentBalancePage: '/fms/billPayment/balancePage', // [GET] {billType} 余额列表-分页
  billPaymentBalanceTotal: '/fms/billPayment/balanceTotal', // [GET] {billType} 余额统计
  billOrderReceivePage: '/fms/billOrderTerm/receivable/page', // 应收租赁列表（按期）
  billOrderReceivePageMonth: '/fms/billOrderTerm/receivable/page/month', // 应收租赁列表(按月)
  billPaymentRegisterStock: '/fms/billPayment/register/stock', // [POST] 库存管理费登记提交
  billPaymentProvisionalSaveOverdue: '/fms/billPayment/provisionalSave/overdue', // [POST] 逾期费账单暂存
  billPaymentProvisionalSave: '/fms/billPayment/provisionalSave/term', // [POST] 租赁暂存
  billPaymentProvisionalSaveStock: '/fms/billPayment/provisionalSave/stock', // [POST] 库存管理费账单暂存
  provisionalSave: '/fms/deposit/provisionalSave', // 应收押金暂存
  billOrderTermPayableFactoryPage: '/fms/billOrderTerm/payable/factory/page', // [GET] 应付列表(总部)-分页
  billOrderTermPayableServicePage: '/fms/billOrderTerm/payable/service/page', // [GET] 应付列表(应付服务费)-分页
  billOrderTermReceivableExport: '/fms/billOrderTerm/receivable/export', // [POST] 导出应收列表
  billOrderTermPayableExport: '/fms/billOrderTerm/payable/export', // [POST] 导出应付账单
  billOrderTermReceivableTotal: '/fms/billOrderTerm/receivable/total', // [GET] 应收列表-总金额统计
  billOrderTermPayableTotal: '/fms/billOrderTerm/payable/total', // [GET] 应付列表-总金额统计
  paymentToAddPayableTotal: '/fms/payment/toAddPayableTotal', // [GET] 账单选择分页列表-付款-统计金额
  depositExport: '/fms/deposit/export', // 财务押金导出

  billPaymentRegisterOverdue: '/fms/billPayment/register/overdue', // [POST] 逾期费账单登记提交
  depositRegisterSave: '/fms/deposit/register', // 应收押金提交
  portalCancelPayment: '/fms/portal/cancelPayment', // [POST] {billPaymentCode} 取消支付订单

  billPaymentBankFlowBind: '/fms/billPayment/bankFlow/bind', // [POST] {tradeId}/{sellerTradeCode} 银行流水绑定
  billPaymentBankFlowUnBind: '/fms/billPayment/bankFlow/unBind', // [POST] {tradeId} 银行流水解绑
  billPaymentBankFlowDelete: '/fms/billPayment/bankFlow/delete', // [POST] {sellerTradeCode} 登记中银行流水删除, 和银行流水解绑效果相同
  billPaymentBankFlowList: '/fms/billPayment/bankFlow/list', // [GET] {billPaymentId} 支付信息的银行流水列表
  billPaymentRevoke: '/fms/billPayment/revoke', // [POST] {billType}/{billId} 撤回或打回或拒绝
  billPaymentRegisterTerm: '/fms/billPayment/register/term', // [POST] 租赁账单提交
  billPaymentConfirmPayment: '/fms/billPayment/confirmPayment', // [POST] {billType}/{billPaymentId} 确认收款

  fmsChangeStockAdd: '/fms/fmsChange/stock/add', // [POST] 库存费免收申请-提交/保存
  fmsChangeRecordsPage: '/fms/fmsChange/records/page', // [GET] 财务变更记录

  // 银行流水
  tradeSellerPage4payment: '/fms/tradeSeller/page4payment', // [GET] 选择银行流水分页列表

  OutInRecord: '/dms/outInRecord/device/page', // 设备详情-出入库记录
  bootCardDevice: '/dms/bootCard/pageForDevice', // 设备已关联开机卡列表
  bootCardListForDevice: '/dms/bootCard/listForDevice', // 设备已关联开机卡列表

  // 路径地图管理
  hlcSlotAppTotalSolt: '/dms/hlcSlot/app/totalSolt', // [GET] {productCode} {siteId} APP-区域定位码卡槽使用数量汇总
  hlcSlotRealTimePage: '/dms/hlcSlot/realTime/page', // [GET] 实时路径地图分页
  hlcSlotHistoryPage: '/dms/hlcSlot/history/page', // [GET] 历史路径地图-分页
  hlcSlotInfo: '/dms/hlcSlot/info', // [GET] {hlcSlotId} 路径信息 (查看来源用oldHlcSlotId)
  hlcSlotDelete: '/dms/hlcSlot/delete', // [POST] {hlcSlotId} 删除路径
  hlcSlotEditMapName: '/dms/hlcSlot/editMapName', // [POST] 修改路径名称
  hlcSlotDeviceList: '/dms/hlcSlot/deviceList', // [GET] {siteId} 区域内设备集合
  hlcSlotAvailableSoltCode: '/dms/hlcSlot/availableSoltCode', // [GET] {hlcSlotId} 可转移的定位槽
  hlcSlotTransfer: '/dms/hlcSlot/transfer', // [POST] 转移路径
  hlcSlotRecover: '/dms/hlcSlot/recover', // [POST] {hlcSlotHistId} 恢复路径
  hlcSlotFindResouse: '/dms/hlcSlot/findResouse', // [GET] {hlcSlotId} 获取路径信息（查看来源）
  hlcSlotAppSoltList: '/dms/hlcSlot/app/soltList', // [GET] {productCode} {siteId} {hlcCode} 区域定位码路线列表
  hlcSlotSoltListByBodyNum: '/dms/hlcSlot/soltListByBodyNum', // [GET] {bodyNum} 设备路径详情

  // iot-事件代码管理
  eventAdd: '/dms/event/add', // [POST] 新增
  eventDelete: '/dms/event/delete', // [POST] {eventId} 删除
  eventInfo: '/dms/event/info', // [GET] 详情
  eventPage: '/dms/event/page', // [GET] 分页列表
  eventUpdate: '/dms/event/update', // [POST] 更新
  eventExport: '/dms/event/export', // [GET] 导出
  eventListForProduct: '/dms/event/listForProduct', // [GET] 获取指定产品下的事件代码
  eventSetNotice: '/dms/event/setNotice', // [POST] 通知设置
  eventTslCodeList: '/dms/event/tsl/codeList', // 可选事件代码
  eventComponentListByProtocolClass: '/dms/event/component/listByProtocolClass', // [GET] 获取指定协议类别的

  // 交易记录(银行流水)
  tradeSellerDownloadTemplate: '/fms/tradeSeller/downloadTemplate', // [GET] 导入流水-下载导入模板
  tradeSellerExcel: '/fms/tradeSeller/excel', // [POST] 导入流水-上传文件
  tradeSellerExcelCheckPage: '/fms/tradeSeller/excel/checkPage', // [GET] 导入流水-验证通过数据分页查询
  tradeSellerExcelExportFailData: '/fms/tradeSeller/excel/exportFailData', // [GET] 新机入库-导出异常数据
  tradeSellerExcelSave: '/fms/tradeSeller/excel/save', // [POST] {flag}导入流水-批量入库
  tradeSellerExport: '/fms/tradeSeller/export', // [GET]合同订单账单分页列表（详情页使用）
  tradeSellerPage: '/fms/tradeSeller/page', // [GET] 交易记录分页列表
  tradeSellerDelete: '/fms/tradeSeller/delete', // [POST] 删除流水 {sellerTradeId}
  tradeSellerBillList: '/fms/tradeSeller/billList', // 流水详情 交易记录已被核销的账单信息
  tradeSellerBillPage: '/fms/tradeSeller/billPage', // 流水详情 交易记录已被核销的账单信息
  tradeSellerInfo: '/fms/tradeSeller/info', // [GET] {sellerTradeCode} 流水详情
  fmsPaymentWriteoffListByTrade: '/fms/fmsPaymentWriteoff/listByTrade', // {sellerTradeCode}流水核销情况
  tradeSellerUnVerifyExport: '/fms/tradeSeller/unVerify/export', // [GET] 导出未核销账单列表
  tradeSelleExcelCheckPage: '/fms/tradeSeller/excel/checkPage', // [GET]导入流水-验证通过数据分页查询
  tradeSellerVerifyExcelSave: '/fms/tradeSeller/verify/excel/save', // [POST] {flag}确认批量核销账单
  tradeSellerVerifyExcel: '/fms/tradeSeller/verify/excel', //  [POST]批量核销账单
  tradeSellerExcelCheckResultExport: '/fms/tradeSeller/excel/checkResult/export', // [GET] 导入流水-验证数据结果导出
  tradeSellerUnVerifyDownloadTemplate: '/fms/tradeSeller/unVerify/downloadTemplate', // [GET] 下载批量核销账单模板

  // 账单应付应收 （逾期费）
  billOrderOverduePayablePage: '/fms/billOrderOverdue/payable/page', // [GET] 应付列表-分页
  billOrderOverdueReceivablePage: '/fms/billOrderOverdue/receivable/page', // [GET] 应收列表-分页
  billOrderOverdueToAddPayablPage: '/fms/billOrderOverdue/toAddPayablPage', // [GET] 应付账单选择分页列表
  billOrderOverdueFreeUpdate: '/fms/billOrderOverdue/free/update', // [POST]  逾期费免收申请-编辑
  billOrderOverdueFreeAdd: '/fms/billOrderOverdue/free/add', // [POST] 免收逾期费
  billOrderOverdueFreeInfo: 'fms/billOrderOverdue/free/info', // [GET] {changeId} 逾期费免收申请-详情

  // 延期收款
  OverdueInfo: '/fms/fmsChange/overdue/info', // 延期收款详情
  OverdueSave: '/fms/fmsChange/overdue/draft', // 保存延期收款
  fmsWithdrawInfoByPaymentId: '/fms/fmsChange/withdraw/infoByPaymentId', // [GET] 通过paymentId获取撤销收款详情
  // 撤销收款
  fmsWithdrawInfo: '/fms/fmsChange/withdraw/info', //  [GET] {billType}/{changeId} 撤销收款详情
  fmsWithdrawDraft: '/fms/fmsChange/withdraw/draft', // [POST] 撤销收款-草稿
  billPaymentInfo: '/fms/billPayment/paymentInfo', // 租赁账单登记详情
  // 应收押金管理
  DepositConfirm: '/fms/billPayment/confirmPayment', // [POST]确认收款
  DepositRevoke: '/fms/billPayment/revoke', //  // [POST]拒绝收款
  DepositInfo: '/fms/deposit/info', // [GET]押金详情
  DepositPage: '/fms/deposit/page', // [GET]分页列表
  DepositPreRefundList: '/fms/deposit/preRefund/list', // [GET]分页列表
  DepositRefundSave: '/fms/deposit/refund/save', // [POST]押金退款暂存/提交
  DepositRefundInfo: '/fms/deposit/refund/info', // [GET] 押金退款明细
  DepositRefundApplyDetail: '/fms/deposit/refund/apply/info', // 申请退押金详情
  DepositPaymentInfo: '/fms/deposit/refund/paymentInfo', // 押金退款详情

  DepositRefundConfirm: '/fms/deposit/refund/confirm', // 押金退款确认收款
  DepositPrepayablePage: '/fms/deposit/prePayable/page', // 付款登记可添加账单列表
  DepositRefundList: '/fms/deposit/refund/preRefundApply/list', // 可申请退款列表
  DepositRefundApply: '/fms/deposit/refund/apply', // 申请退款
  // DepositProvisionalSave: '/fms/deposit/provisionalSave', // [POST] 租赁账单暂存
  // DepositRegister: '/fms/deposit/register', // [POST]租赁账单登记提交

  // 已收首付款未启租
  prepaymentUnRenPage: '/fms/prepayment/unRent/page',
  prepaymentConfirmInfo: '/fms/prepayment/paymentInfo',
  prepaymentSubmit: '/fms/prepayment/confirm',
  // 应退租金

  // 库存管理费
  stockOrderPage: '/crms/crm/stockOrder/page', // [GET] 库存管理费-分页
  stockOrderExport: '/crms/crm/stockOrder/export', // [GET] 库存管理费-导出

  // 设备翻新
  renovateApplyDelete: '/asm/renovateApply/delete', // 删除/{applyId}
  renovateApplyInfo: '/asm/renovateApply/info', // 设备翻新申请详情
  renovateApplyPage: '/asm/renovateApply/page', // 设备翻新分页列表
  renovateApplySaveOrUpdate: '/asm/renovateApply/saveOrUpdate', // 设备翻新申请保存更新
  renovateApplyDeviceDelete: '/asm/renovateApplyDevice/delete', // {applyDeviceId}//翻新申请设备删除
  // 设备翻新
  renovate: '/dms/renovate', // {deviceId}设备翻新
  renovateBatch: '/dms/renovate/batch', // {flag}新机入库-批量入库
  renovateDownloadTemplate: '/dms/renovate/downloadTemplate', // 下载导入模板
  renovateExcel: '/dms/renovate/excel', // 批量翻新检测
  renovateExcelCheckPage: '/dms/renovate/excel/checkPage', // 新机入库-验证通过数据分页查询
  renovateExcelExportFailData: '/dms/renovate/excel/exportFailData', // 新机入库-导出异常数据
  renovateRecordPage: '/asm/renovate/record/page', // 翻新记录分页
  renovateRecordExport: '/asm/renovate/record/export', // 导出零件
  // 库存管理费变更
  stockOrderChangeAdd: '/crms/crm/stockOrderChange/add', // [POST] 延期申请-提交/保存
  stockOrderChangeDelete: '/crms/crm/stockOrderChange/delete', // [POST] {changeOrderId} 延期申请-删除
  stockOrderChangeInfo: '/crms/crm/stockOrderChange/info', // [GET] {changeOrderId} 延期申请-详情
  stockOrderChangePage: '/crms/crm/stockOrderChange/page', // [GET] 延期申请-分页
  stockOrderChangeUpdate: '/crms/crm/stockOrderChange/update', // [POST] 延期申请-编辑

  // 库存管理费记录
  stockOrderRecordPage: '/crms/crm/stockOrderRecord/page', // [GET] 库存费记录-分页
  stockOrderRecordExport: '/crms/crm/stockOrderRecord/export', // [GET] 库存费记录-导出

  // 订单发货
  orderDeliveryInfo: '/crms/lms/orderDelivery/info', // [GET] 发货详情

  // 设备签收记录
  orderDeliveryMonthPage: '/crms/orderDelivery/month/page', // [GET] 分页列表
  orderDeliveryMonthDetail: '/crms/orderDelivery/month/detail', // [GET] 明细列表
  orderDeliveryMonthUpdate: '/crms/orderDelivery/month/update', // [POST] 编辑
  orderDeliveryMonthEnableUpdatePage: '/crms/orderDelivery/month/enableUpdate/page', // [GET] 可更新发货设备列表
  orderDeliveryMonthAttach: '/crms/orderDelivery/month/attach', // [POST] 关联附件
  orderDeliveryMonthConfirm: '/crms/orderDelivery/month/confirm', // [POST] {id} 确认
  orderDeliveryMonthRefuse: '/crms/orderDelivery/month/refuse', // [POST] {id} 重新上传
  orderDeliveryMonthExport: '/crms/orderDelivery/month/export', // [POST] 导出

  // 库存费管理应收应付
  billOrderStockPayablePage: '/fms/billOrderStock/payable/page', // [GET] 应付列表-分页
  billOrderStockReceivablePage: '/fms/billOrderStock/receivable/page', // [GET] 应收列表-分页
  billOrderStockToAddPayablePage: '/fms/billOrderStock/toAddPayablePage', // [GET] 应付账单选择分页列表

  billRefundRentInfo: '/fms/billOrderRefundRent/paymentInfo', // 账单登记详情
  billRefundExport: '/fms/billOrderRefundRent/receivable/export', // 应收导出
  billPayRefundExport: '/fms/billOrderRefundRent/payable/export', // 应付导出
  billRefundRent: '/fms/billOrderRefundRent/payable/page', // 应退分页列表
  billRecevieRefund: '/fms/billOrderRefundRent/receivable/page', // 应收退款分页列表
  billAddPayablePage: '/fms/billOrderRefundRent/toAddPayablePage', // 应付账单分页列表
  refundRentSave: '/fms/billPayment/provisionalSave/refundRent', // 应退暂存
  refundRentSubmit: '/fms/billPayment/register/refundRent', // 提交
  billOrderRefundRentSave: '/fms/billOrderRefundRent/save', // 应退租金提交
  // refundRentSave: '/fms/billPayment/provisionalSave/refundRent', // 应退暂存
  // refundRentSubmit: '/fms/billPayment/register/refundRent', // 提交
  // 发票
  invoiceAllPage: '/fms/invoice/page', // 发票列表(已提交/开票中/已开票)
  invoiceListExport: '/fms/invoice/list/export', // 发票列表(已提交/开票中/已开票)导出
  invoiceWaitPage: '/fms/invoice/page/wait2Invoice', // 发票列表(待开票)
  invoiceWaitExport: '/fms/invoice/wait2Invoice/export', // 发票列表(待开票)导出
  invoiceGoRedBill: '/fms/invoiceGoRedNew/page/selectBill', // 获取期账单列表
  invoiceMonthBill: '/fms/invoiceGoRedNew/list/selectMonthBill', // 获取月账单列表(by期账单)

  invoiceWaitTplDownload: '/fms/waitInvoice/downloadTemplate', // 下载导入模板(导入待开票)
  invoiceWaitExcelImport: '/fms/waitInvoice/excel/import', // 上传导入验证(导入待开票)
  invoiceWaitExcelSave: '/fms//waitInvoice/import/save', // 保存导入验证(导入待开票)

  invoiceDelete: '/fms/invoice/delete', // 删除（待开票）
  invoiceInvalid: '/fms/invoice/finish/invalid', // 作废（已开票）
  invoiceInvalidBatch: '/fms/invoice/finish/invalid/batch', // 作废批量（已开票）
  invoiceSubmit: '/fms/invoice/submit', // 保存提交草稿（开票审批）
  invoiceSync2U8: '/fms/invoice/sync2U8', // U8同步开票
  invoiceGoRedSelect: '/fms/invoiceGoRed/page/selectMonthBill', // 选择冲红月账单
  invoiceGoRedSelectList: '/fms/invoiceGoRed/list/selectMonthBill', // 选择冲红月账单
  invoiceGoRedDraft: '/fms/invoiceGoRed/draft', // 保存草稿-正常开票-冲红审批(旧)
  invoiceGoRedNewDraft: '/fms/invoiceGoRedNew/draft', // 提交冲红审批草稿（新）
  invoiceEditDetail: '/fms/invoice/batch', // 获取审批详情
  invoiceGoRedInvoiceGoRed: '/fms/invoiceGoRed/invoiceGoRed', // [GET]  冲红 单个发票详情{invoiceId}

  invoiceMargeBill: '/fms/invoice/margeBill', // [GET] 合并账单预览发票信息
  invoiceDetail: '/fms/invoice/detail', // [GET]{invoiceId}单个正常发票详情
  invoiceRegister: '/fms/invoice/register', // [POST]登记开票
  invoiceGoRedPreview: '/fms/invoiceGoRed/preview', // [POST]预览冲红发票（旧）
  invoiceGoRedNewPreview: '/fms/invoiceGoRedNew/preview', // [POST]预览冲红发票（新）
  invoiceGoRedRegister: '/fms/invoiceGoRed/register', // [POST]冲红登记开票
  invoiceGoRedDetail: '/fms/invoiceGoRed/invoiceGoRed/detail', // {invoiceId}传入冲红发票ID 发票详情(旧)
  invoiceGoRedNewDetail: '/fms/invoiceGoRedNew/invoiceGoRed/detail', // {invoiceId}传入冲红发票ID 发票详情（新）
  invoiceBlueGoRedBillList: '/fms/invoiceGoRedNew/getBlueInvoiceBillList', // {invoiceId} 获取原发票列表

  // invoiceGoRedDetailByOldInvoiceId: '/fms/invoiceGoRed/invoiceGoRed/detailByOldInvoiceId', //  [GET] {oldInvoiceId}传入原发票ID 查看冲红详情（接口已删除， 上面那个接口兼容）
  invoicePage4Buyer: '/fms/invoice/page4Buyer', // [GET]发票列表-已提交 - 开票中 - 已开票 (收票方)
  invoicePage4BuyerExport: '/fms/invoice/page4Buyer/export', // [GET]发票列表-已提交 - 开票中 - 已开票 (收票方) 导出
  invoicePage4BuyerWait2Invoice: '/fms/invoice/page4Buyer/wait2Invoice', // [GET]租赁账款待开票列表-分页（收票方）
  invoicePage4BuyerWait2InvoiceExport: '/fms/invoice/page4Buyer/wait2Invoice/export', // [GET]租赁账款待开票列表-分页（收票方）导出
  invoiceGoRedOldDetail: '/fms/invoiceGoRed/oldInvoiceInfo',

  // 设备账单详情
  billOrderDetailBasicInfo: '/fms/billOrderDetail/basicInfo', // [GET]{billId}设备账单详情-左侧基础信息
  billOrderDetailListPayable: '/fms/billOrderDetail/list/payable', // [GET]设备账单详情-应付列表
  billOrderDetailListReceivable: '/fms/billOrderDetail/list/receivable', // [GET]设备账单详情-应收列表
  billOrderDetailOverdueReceivable: '/fms/billOrderDetail/overdue/receivable', // [GET]设备账单详情-应收逾期费列表
  billOrderDetailPaymentPayable: '/fms/billOrderDetail/payment/payable', // [GET]设备账单详情-付款记录
  billOrderDetailPaymentReceivable: '/fms/billOrderDetail/payment/receivable', // [GET]设备账单详情-收款记录
  billOrderDetailPaymentInfo: '/fms/billOrderDetail/paymentInfo', // {billPaymentId}付款信息详情

  // 财务我的账户
  portalBillInvoiceDetail: '/fms/portal/bill/invoiceDetail', // [GET] {billId} 账单查看发票

  // 财务变更
  fmsChangeStockInfo: '/fms/fmsChange/stock/info', // [GET] {changeId} 库存费免收申请-详情
  fmsChangeFreeCancel: '/fms/fmsChange/free/cancel', // [POST]  取消免收（库存管理费、逾期费）

  // 基础服务项
  BasicItemAdd: '/asm/basicItem/add', // 添加
  BasicItemDelete: '/asm/basicItem/delete', // {itemId} 删除
  BasicItemInfo: '/asm/basicItem/info', // {itemId} 详情
  BasicItemPage: '/asm/basicItem/page', // 分页
  BasicItemUpdate: '/asm/basicItem/update', // 编辑
  BasicItemListByProduct: '/asm/basicItem/listByProduct', // 获取产品的保养列表
  BasicItemList: '/asm/basicItem/list', // 列表
  BasicItemGroupMaxItemVersion: '/asm/basicItemGroup/maxItemVersion', // [GET] 当前产品的最大返工项目版本
  BasicItemGroupItemVersions: '/asm/basicItemGroup/itemVersions', // [GET] 返工项 版本下拉 (废弃)

  // 零件管理
  PartPreAssociatePage: '/asm/part/preAssociatePage',

  // 质量反馈
  feedbackApply: '/asm/feedback/apply', // 反馈申请
  feedbackApprovalResultInfo: '/asm/feedback/approvalResult/info', // 反馈结果详情
  feedbackDelete: '/asm/feedback/delete', // {feedBackId}删除反馈信息
  feedbackExport: '/asm/feedback/export', // 导出
  feedbackInfo: '/asm/feedback/info', // 详情
  feedbackLogList: '/asm/feedback/log/list', // 动态列表
  feedbackPage: '/asm/feedback/page', // 分页列表
  feedbackTagAdd: '/asm/feedback/tag/add', // 词条列表
  feedbackTagList: '/asm/feedback/tag/list', // 词条列表
  feedbackUpdate: '/asm/feedback/update', // 配置列表
  feedbackUpdateApproveInfo: '/asm/feedback/updateApproveInfo', // 编辑反馈信息
  feedbackIsRepeatApply: '/asm/feedback/isRepeatApply', // {orderPartId}验证是否重复申请
  // 案例订单
  caseOrderGenerateWorkOrder: '/asm/caseOrder/generateWorkOrder', // [POST] 分派或者重新分派工单
  caseOrderInfo: '/asm/caseOrder/info', // [GET] {caseOrderId} case工单详情
  caseOrderPage: '/asm/caseOrder/page', // [GET] case工单分页列表（客服）
  caseOrderSave: '/asm/caseOrder/save', // [POST] case工单创建（客服）
  caseOrderUpdatePriority: '/asm/caseOrder/updatePriority', // [POST] 更改case工单信息（紧急程度）
  caseOrderUpdateState: '/asm/caseOrder/updateState', // [POST] 更改case工单状态（关单/受理）
  caseOrderUpdateServiceRemark: '/asm/caseOrder/updateServiceRemark', // [POST] 更改case客服受理意见[删除]
  caseOrderPage4Portal: '/asm/caseOrder/page4Portal', // [GET] case工单分页列表（portal）
  caseOrderSave4Simple: '/asm/caseOrder/save4Simple', // [POST] 一键生成case工单生成【默认保养】

  // 设备业务管理
  DeviceBizScStockPage: '/dms/device/biz/sc/stock/page', // [GET] 客服关联的售后公司库存设备分页
  DeviceBizStockPage: '/dms/device/biz/stock/page', // [GET] 组织库存设备（默认查当前登录人组织）

  // 案例处理建议
  // auth: 呆萌
  caseOrderProposalList: '/asm/caseOrderProposal/list', // 列表
  caseOrderProposalDelete: '/asm/caseOrderProposal/delete', // [POST] {orderProposalId}  删除
  caseOrderProposalInfo: '/asm/caseOrderProposal/info', // [GET]  {orderProposalId} 详情
  caseOrderProposalSave: '/asm/caseOrderProposal/save', // [POST] 新增
  caseOrderProposalUpdate: '/asm/caseOrderProposal/update', // [POST] 更新

  // 案例更换零件建议
  caseOrderPartDelete: '/asm/caseOrder/part/delete', // [POST] {orderPartId} 删除
  caseOrderPartPage: '/asm/caseOrder/part/page', // [GET] 建议携带零件列表
  caseOrderPartSave: '/asm/caseOrder/part/save', // [POST] 保存
  caseOrderPartSelectPage: '/asm/caseOrder/part/selectPage', // [GET] 可选择零件列表
  caseOrderPartSetNum: '/asm/caseOrder/part/setNum', // [POST] 设置数量
  caseOrderPartSysList: '/asm/caseOrder/part/sys/list', // [POST]  系统建议更换零件列表

  // 工单相关操作
  WorkOrderOptArrivals: '/asm/workOrder/opt/arrivals', // [POST] 到达
  WorkOrderOptCloseOrder: '/asm/workOrder/opt/closeOrder', // [POST] 关闭订单
  WorkOrderOptConfirmOrder: '/asm/workOrder/opt/confirmOrder', // [POST] {workOrderId} 接单
  WorkOrderOptFinish: '/asm/workOrder/opt/finish', // [POST] 解除故障
  WorkOrderOptNotFix: '/asm/workOrder/opt/notFix', // [POST] 无法解决
  WorkOrderOptSetOut: '/asm/workOrder/opt/setOut', // [POST] 出发
  WorkOrderOptStartWork: '/asm/workOrder/opt/startWork', // [POST] {workOrderId} 开始工作
  WorkOrderOptTransferWork: '/asm/workOrder/opt/transferWork', // [POST] 转派工单
  WorkOrderUnfinished: '/asm/workOrder/unfinished', // [GET] 获取设备未完成的工单

  // 不在线设备
  DmsDeviceOfflineEditRemark: '/dms/dmsDeviceOffline/edit/remark', // [POST] 修改备注(离线设置)
  DmsDeviceOfflineListDeviceStatus: '/dms/dmsDeviceOffline/list/deviceStatus', // [GET] 获取设备不在线状态
  DmsDeviceOfflinePage: '/dms/dmsDeviceOffline/page', // [GET] 不在线列表-分页
  // /workOrder/page/deviceWorkOrders/offline/{bodyNum}
  DmsDeviceOfflinePageMyself: '/dms/dmsDeviceOffline/page/myself', // [GET] 离线设备，个人设备
  DmsDeviceOfflinePageOrg: '/dms/dmsDeviceOffline/page/org', // [GET] 离线设备，组织设备
  DmsDeviceOfflineMyselfExport: '/dms/dmsDeviceOffline/myself/export', // [POST]  导出 - 我的设备
  DmsDeviceOfflineOrgExport: '/dms/dmsDeviceOffline/org/export', // [POST]  导出 - 组织设备

  // 预览账单
  previewBillAfterService: '/fms/billOrderTerm/previewBill/afterService',
  previewBillChangeDevice: '/fms/billOrderTerm/previewBill/changeDevice',
  previewBillPaymentPeriod: '/fms/billOrderTerm/previewBill/paymentPeriod',
  previewBillStartTime: '/fms/billOrderTerm/previewBill/startTime',

  // 违约金
  billBreakPayablePage: '/fms/billBreak/payable/page', // [GET] 应付列表-分页
  billBreakReceivablePage: '/fms/billBreak/receivable/page', // [GET] 应收列表-分页
  billBreakPayableExport: '/fms/billBreak/payable/export', // [GET] 应付导出
  billBreakReceivableExport: '/fms/billBreak/receivable/export', // [GET] 应收导出
  billBreakFreeAdd: '/fms/billBreak/free/add', // [POST] 违约金免收申请-保存
  billBreakFreeUpdate: '/fms/billBreak/free/update', // [POST] 违约金免收申请-编辑
  billBreakFreeInfo: '/fms/billBreak/free/info', // [GET] {changeId} 违约金免收申请-详情

  // 余额相关
  partnerBalanceAccountBalanceExport: '/fms/partnerBalance/accountBalance/export', // [POST] 余额列表-收入支出-导出
  partnerBalanceAccountBalancePage: '/fms/partnerBalance/accountBalancePage', // [GET] 余额列表-收入支出
  partnerBalanceRecordPage: '/fms/partnerBalance/record/page', // [GET] 余额收入明细
  partnerBalanceRecordExport: '/fms/partnerBalance/record/export', // [POST] 余额收入明细-导出

  // 数据迁移
  idmFunctionList: '/idm/idmFunction/list', // [GET] 功能任务设置列表
  idmFunctionUpdate: '/idm/idmFunction/update', // [POST] 修改功能任务

  batchRecordList: '/idm/batchRecord/list', // [GET] 所有批次列表
  batchRecordDelete: '/idm/batchRecord/delete', // [POST] {id} 删除任务
  batchRecordStopAllTask: '/idm/batchRecord/stopAllTask', // [POST] {batchNum} 暂停
  batchRecordStartAllTask: '/idm/batchRecord/startAllTask', // [POST] {batchNum} 执行
  batchRecordClearAllData: '/idm/batchRecord/clearAllData', // [POST] {batchNum} 清除数据
  batchRecordSave: '/idm/batchRecord/save', // [POST]  创建、修改批次总任务
  batchRecordInfo: '/idm/batchRecord/info', // [GET] {id} 批次信息

  batchRecordProgress: '/idm/batchRecord/progress', // [GET] {batchNum} 总任务所有任务进度统计
  batchRecordTaskList: '/idm/batchRecord/taskList', // [GET] 批次的所有任务(任务详情的任务列表)

  functionTaskBatchClearData: '/idm/functionTask/batch/clearData', // [POST] {batchNum} 批量清除数据
  functionTaskBatchDelete: '/idm/functionTask/batch/delete', // [POST] 批量-删除任务
  functionTaskBatchStartTask: '/idm/functionTask/batch/startTask', // [POST] 批量开启任务
  functionTaskBatchStopTask: '/idm/functionTask/batch/stopTask', // [POST] 批量停止任务
  functionTaskAddThread2Task: '/idm/functionTask/addThread2Task', // [POST] 给任务增加线程数
  functionTaskErrorLog: '/idm/functionTask/errorLog', // [GET] {taskId} 错误日志

  // portal

  // 门户-设备管理
  PortalDeviceAsmCount: '/dms/portal/device/asm/count', // 售后统计
  PortalDeviceAsmPage: '/dms/portal/device/asm/page', // 设备列表【售后统计页】
  PortalDeviceBizPage: '/dms/portal/device/biz/page', // 设备业务列表【设备管理页】
  PortalDeviceFmsBizPage: '/dms/portal/device/fmsBiz/page', // 设备明细【财务统计】
  PortalDeviceInfo: '/dms/portal/device/info', // 获取设备详情【设备id】
  PortalDevicePage: '/dms/portal/device/page', // 设备列表【设备统计页】
  PortalDeviceProductPage: '/dms/portal/device/product/page', // 产品分页
  PortalDeviceStatusCount: '/dms/portal/device/status/count', // 状态统计
  PortalDeviceWorkOrderPage: '/dms/portal/device/workOrder/page', // 维修/保养记录列表【售后统计页】

  // 财务数据统计
  PortalDeviceTotalExpire: '/fms/portal/deviceTotalExpire', // 设备到期时间统计图
  PortalListCustomers: '/fms/portal/list/customers', // 集团租赁方下拉
  PortalPageWaitPayCompany: '/fms/portal/page/waitPay/company', // 按公司分类-待支付分页-如果选择了项目，则不调用
  PortalPageWaitPayProject: '/fms/portal/page/waitPay/project', // 按公司分类-待支付分页-如果选择了租赁方，则不调用
  PortalPayablePage: '/fms/portal/payable/page', // 应付列表(期)-分页
  PortalTotalBasic: '/fms/portal/total/basic', // 基础数量统计：本月待付、下月待付、90天待支付、设备数量、子公司数量、项目数量
  PortalTotalExpireByCompany: '/fms/portal/totalExpireByCompany', // 设备到期数按公司分组
  PortalTotalExpireByProject: '/fms/portal/totalExpireByProject', // 设备到期数按项目分组
  PortalDeviceBillDetailPage: '/fms/portal/deviceBillDetail/page', // [GET] // 设备明细-历史账单-分页

  // 设备管理
  portalDeviceBizPage: '/dms/portal/device/biz/page', // [GET]设备业务列表【设备管理页】
  portalDeviceUpdateDeviceName: '/dms/portal/device/update/deviceName', // [GET]修改设备名称 {deviceId}/{deviceName}
  portalDeviceInfo: '/dms/portal/device/info', // [GET]获取设备详情【设备id】
  portalDevicePage: '/dms/portal/device/page', // [GET]设备列表【设备统计页】
  portalDeviceProductPage: '/dms/portal/device/product/page', // [GET]产品分页
  portalDeviceStatusCount: '/dms/portal/device/status/count', // [GET]状态统计

  portalOrgGetCsByParentId: '/base/portal/org/getCsByParentId', // [GET]大客户下租赁方列表
  portalDeviceLocationList: '/dms/portal/device/location/list', // [GET]项目列表
  portalOrgDeviceCountPage: '/base/portal/org/deviceCount/page', // [GET] 大客户下租赁方列表(公司)
  portalDeviceLocationPage: '/dms/portal/device/location/page', // [GET]项目统计列表(项目)
  portalDeviceSitePage: '/dms/portal/device/site/page', // [GET]区域统计列表(区域)
  portalDeviceList: '/dms/portal/device/list', // [GET]设备列表【设备统计页】

  // 线下服务
  serviceModemPage: '/dms/serviceModem/page', // modem分页
  serviceModemSaveOrUpdate: '/dms/serviceModem/saveOrUpdate', // modem审批提交
  serviceModemUpdateState: '/dms/serviceModem/updateState', // {modemServiceId}/{state}更新状态
  serviceModemInfo: '/dms/serviceModem/info', // {modemServiceId}详情
  serviceModemRecordSave: '/dms/serviceModemRecord/save', // 保存
  serviceModemRecordUpdate: '/dms/serviceModemRecord/update', // 编辑
  serviceModemRecordInfo: '/dms/serviceModemRecord/info', // {serviceRecordId}详情
  componentTopicList: '/dms/component/topicList', // 更换零件时系统主动下发Topic集合
  serviceModemDeviceData: '/dms/serviceModem/deviceData', // 获取设备实时数据
  serviceModemTaskSave: '/dms/serviceModemTask/save', // 保存modem与设备下发记录
  serviceModemRecordPage: '/dms/serviceModemRecord/page', // 分页

  // 报表
  reportFinanceBiz: '/fms/staRentalInvoice/page',
  reportFinanceBizExport: '/fms/staRentalInvoice/export',
  reportFinanceBizRefresh: '/fms/staRentalInvoice/refresh',
  reportFinanceBizRefreshProgress: '/fms/staRentalInvoice/refreshProgress',

  staRevenueOrderBillPage: '/fms/staRevenueOrderBill/page', // 客户报表
  staRevenueOrderBillExport: '/fms/staRevenueOrderBill/export', // 导出-客户报表
  staRevenueOrderBillRefresh: '/fms/staRevenueOrderBill/refresh', // 刷新数据-客户报表
  staRevenueOrderBillRefreshProgress: '/fms/staRevenueOrderBill/refreshProgress', // 刷新数据-客户报表-进度 剩余个数
  staRevenueOrderBillRefreshPayment: '/fms/staRevenueOrderBill/refreshPayment', // 刷新数据-收付款信息
  staRevenueOrderBillRefreshPaymentProgress: '/fms/staRevenueOrderBill/refreshPaymentProgress', // 刷新数据-收付款信息-进度 剩余个数
  partnerSelectOrgan: '/crms/crm/partner/select/organ', // 下级组织下拉 [通用]  childOrgType

  // 发货计划
  shipPlanPage: '/crms/shipPlan/page', // 发货计划列表
  shipPlanAdd: '/crms/shipPlan/add', // 添加发货计划
  shipPlanConsigneeUpdate: '/crms/shipPlan/consignee/update', // 可选设备列表
  shipPlanDeviceNoSelect: '/crms/shipPlan/deviceNo/select', // 设备号选择列表
  shipPlanInfo: '/crms/shipPlan/info', // 发货计划详情
  shipPlanOrderInfo: '/crms/shipPlan/orderInfo', // 订单信息，添加发货单时用
  shipPlanBatchInfo: '/crms/shipPlan/batchInfo', // 打印发货计划详情
  shipPlanGoods: '/crms/shipPlan/goods', // 发货清单
  shipPlanSave: '/crms/shipPlan/ship', // 发货提交
  shipPlanDeviceTotal: '/crms/shipPlan/deviceTotal', // 设备数量统计
  shipPlanExport: '/crms/shipPlan/export', // 导出计划
  shipPlanDelete: '/crms/shipPlan/delete', // {id}删除发货计划
  shipPlanSmsSendCode: '/crms/shipPlan/sms/sendCode', // 发送收货码

  // 设备类型变更记录
  deviceBizTypeChangePage: '/dms/device/bizType/changePage', // [GET]设备类型变更记录
  // 项目变更记录
  deviceLocationChangePage: '/dms/device/location/changePage', // [GET]项目变更记录
  deviceLocationChangeExport: '/dms/device/locationChange/export', // [GET]手动变更记录导出
  sharingRuleList: '/crms/rms/sharingRule/ruleList', // 租赁方案-分成方案列表
  // 机器人工作记录
  workRunRobotPage: '/dms/workRun/robot/page', // 机器人工作记录分页[数据分析页]
  workRunRobotExport: '/dms/workRun/robot/export', // 机器人设备记录导出
  organRelationOrganList: '/base/organ/relation/organList', // 下级组织列表
  workRunRobotUpdateEventParam: '/dms/workRun/robot/updateEventParam', // 更新工作记录中的事件相关参数 [辅助、碰撞、悬崖次数]
  workRunRobotEventPage: '/dms/workRun/robot/event/page', // 机器人工作记录关联的时间分页
  // 返工
  reworkItemGroupPage: '/asm/basicItemGroup/page', // 返工版本分页
  reworkItemGroupSave: '/asm/basicItemGroup/save', // 保存
  reworkItemGroupUpdate: '/asm/basicItemGroup/update', // 更新
  reworkItemGroupDelete: '/asm/basicItemGroup/delete', // 删除
  reworkItemGroupInfo: '/asm/basicItemGroup/info', // 信息
  reworkItemPage: '/asm/basicItemGroup/item/page', // 返工项分页
  reworkItemDelete: '/asm/basicItemGroup/item/delete', // 返工项删除
  reworkPublish: '/asm/basicItemGroup/isPublish', // 发布、取消发布
  reworkComponent: '/dms/component/treeList', // 返工项目部件列表

  // 角色管理
  roleGetUserList: '/base/role/getUserList', // 通过角色编号、组织ID获取用户

  // SIM isp 管理
  simIspPage: '/dms/simIsp/page', // [GET] isp 列表
  simIspExport: '/dms/simIsp/export', // [GET] isp 导出
  simIspStatePage: '/dms/simIsp/state/page', // [GET] 状态变更分页
  simIspDataPage: '/dms/simIsp/data/page', // [GET] 流量使用记录分页
  simIspDataExport: '/dms/simIsp/data/export', // [GET] 流量使用记录导出
  simIspChangeCountry: '/dms/simIsp/changeCountry', // [POST] SIM卡国家变更
  simIspCountryDownloadTemplate: '/dms/simIsp/country/downloadTemplate', // [GET]SIM卡国家导入-下载模板
  simIspCountryExportFail: '/dms/simIsp/country/exportFail', //  [GET]SIM卡国家导入-失败页导出 {batchNum}
  simIspCountryImport: '/dms/simIsp/country/import', // [POST] SIM卡国家导入-上传文件
  simIspCountryImportSave: '/dms/simIsp/country/import/save', // [POST] SIM卡国家导入-保存 {batchNum}
  simIspCountryImportFailPage: '/dms/simIsp/country/importFail/page', //  [GET]SIM卡国家导入-失败页 {batchNum}
  simIspCountryImportSuccessPage: '/dms/simIsp/country/importSuccess/page', //  [GET]SIM卡国家导入-成功页{batchNum}
  simIspStateDownloadTemplate: '/dms/simIsp/state/downloadTemplate', // [GET] SIM卡状态导入-下载模板
  simIspStateImportSuccessPage: '/dms/simIsp/state/importSuccess/page', // [GET] {batchNum} SIM卡状态导入-成功页
  simIspStateImportFailPage: '/dms/simIsp/state/importFail/page', // [GET] {batchNum} SIM卡状态导入-失败页
  simIspStateExportFail: '/dms/simIsp/state/exportFail', // [GET] {batchNum} SIM卡状态导出
  simIspStateImport: '/dms/simIsp/state/import', // [POST] SIM卡状态导入-上传文件
  simIspStateImportSave: '/dms/simIsp/state/import/save', // [POST] {batchNum} SIM卡状态导入-保存

  // SIM isp 任务管理
  simIspTaskPage: '/dms/simIspTask/page', // [GET]  SIM isp 任务管理列表
  simIspTaskDetail: '/dms/simIspTask/detail', // [GET]  SIM isp 任务明细

  // 配件成本
  giveawayCostsharePage: '/crms/rms/giveaway/costshare/page', // [GET]配件成本-分页
  giveawayCostsharePageExport: '/crms/rms/giveaway/costshare/page/export', // [GET]配件成本导出
  giveawayCostsharePartEditCost: '/crms/rms/giveaway/costshare/part/editCost', // [POST]编辑成本-配件列表
  giveawayCostsharePartList: '/crms/rms/giveaway/costshare/part/list', // [GET]{orderDeviceId}编辑成本-配件列表
  giveawayCostsharePageTotal: '/crms/rms/giveaway/costshare/page/total', // [GET]配件成本分摊汇总-分页
  giveawayCostsharePageTotalExport: '/crms/rms/giveaway/costshare/page/total/export', // [GET]配件成本分摊汇总导出
  giveawayCostshareDetail: '/crms/rms/giveaway/costshare/detail', // [GET] 分摊详情{orderGiveawayId}
  // 财务
  giveawayOrderReceivableCreate: '/fms/fms/giveawayOrder/receivable/create', // [POST] 应收账单-赠送配件
  // 锁机清洁设备
  lockCleanPage: '/dms/lockClean/page', // [GET]锁机清洁设备列表
  lockCleanExport: '/dms/lockClean/export', // [GET]锁机清洁设备导出
  // admin portal
  deviceGlobalList: '/dms/device/globalList', // [GET]机身号搜索
  adminPortalDeviceBizCount: '/report/dms/adminPortal/device/biz/count', // [GET]机器业务状态统计
  adminPortalDeviceStatusCount: '/dms/adminPortal/device/status/count', // [GET]机器状态统计
  adminPortalfaultProductCount: '/dms/adminPortal/fault/product/count', // [GET]故障型号统计
  adminPortalProductComponent: '/dms/adminPortal/product/component', // [GET]产品-组件
  adminPortalProductComponentVersionCount: '/dms/adminPortal/product/component/versionCount', // [GET]产品-组件-版本统计
  adminPortalProductCount: '/dms/adminPortal/product/count', // [GET]机器业务状态统计
  workOrderStatistics: '/asm/workOrder/statistics', // [GET]工单情况统计
  billOrderTermStatistics: '/fms/billOrderTerm/statistics', // [GET] 应收/应付账单统计
  adminPortalDeviceHistCount: '/dms/adminPortal/device/status/hist/count', // [GET]机器历史统计
  adminPortalOrderHistCount: '/crms/adminPortal/order/hist/count', // [GET]机器状态统计
  adminPortalDeviceWorkHistCount: '/dms/adminPortal/device/work/hist/count', // 机器运行上传历史统计
  billOrderTermTrendChart: '/fms/billOrderTerm/trendChart', // [GET] 应收/应付账单趋势图
  workOrderTrendChart: '/asm/workOrder/trendChart', // [GET] 工单趋势图
  adminPortalTrendChartCustomer: '/crms/adminPortal/trendChart/customer', // [GET]客户数量趋势图
  adminPortalClean: '/report/dms/adminPortal/clean', // [GET] 机器清洁趋势图
  adminPortalTrendChartDeviceBiz: '/crms/adminPortal/trendChart/device/biz', // [GET]机器业务趋势图
  modemBatteryEventStatistics: '/dms/modemBattery/event/statistics', // [GET] 故障排行表-事件记录统计
  adminPortalDeviceBumpeCountPage: '/dms/adminPortal/device/bumpeCount/page', // [GET] iot-碰撞触发分页
  adminPortalDeviceCliffCountPage: '/dms/adminPortal/device/cliffCount/page', // [GET] iot-悬崖触发分页
  adminPortalDeviceUnCompleteRecordPage: '/dms/adminPortal/device/unCompleteRecord/page', // [GET] iot-未完成清洁记录分页
  adminPortalDeviceUnUploadCleanRecordPage: '/dms/adminPortal/device/unUploadCleanRecord/page', // [GET] iot-未上传清洁记录分页
  adminPortalDeviceUnUploadMapPage: '/dms/adminPortal/device/unUploadMap/page', // [GET] iot-未上传地图分页
  adminPortalDeviceUnUploadMapCount: '/dms/adminPortal/device/unUploadMap/count', // [GET] iot-未上传地图统计
  adminPortalDeviceUnUploadUsePicPage: '/dms/adminPortal/device/unUploadUsePic/page', // [GET] iot-未上传使用图片分页
  favoriteQueryMenu: '/base/favorite/query/menu', // [GET] 当前用户收藏且有权限访问的菜单
  favoriteAdd: '/base/favorite/add', // [POST] 添加收藏菜单
  approveWaitApproveStatistics: '/crms/aps/approve/waitApprove/statistics', // [POST] 待办事项
  timeZoneGetCompanyList: '/base/timeZone/getCompanyList', //  [GET] (总部管理、租赁方、服务公司、集团客户)公司获取时区
  timeZoneInitTimeZoneList: '/base/timeZone/initTimeZoneList', // [GET] 获取所有时区
  locationUpdateTimeZone: '/dms/location/update/timeZone', // 批量修改时区
  eventRankingDeviceStatistics: '/dms/event/ranking/device/statistics', // [GET] 故障排行表-机器统计列表
  eventRankingDeviceStatisticsExport: '/dms/event/ranking/device/statistics/export', // [GET] 故障排行表-机器事件-导出
  eventRankingDateStatistics: '/dms/event/ranking/date/statistics', // [GET] 故障排行表-日期统计列表
  eventRankingDateStatisticsExport: '/dms/event/ranking/date/statistics/export', // [GET] 故障排行表-日期事件-导出
  eventRankingList: '/dms/event/ranking/list', // [GET] 故障排行表-故障列表
  eventRankingListExport: '/dms/event/ranking/list/export', // [GET] 故障排行表-故障列表-导出
  eventRankingTotal: '/dms/event/ranking/total', // [GET] 故障排行表-机器数，事件数统计
  organCsCoList: '/base/organ/csCoList', // [GET] 租赁方、服务公司列表

  deviceChangeRuleInfo: '/dms/device/bizType/swapRule/info', // 设备更换详情
  deviceChangeRulePage: '/dms/device/bizType/swapRule/page', // 设备更换分页
  deviceChangeRuleSave: '/dms/device/bizType/swapRule/save', // 设备更换详保存
  deviceChangeRuleDelete: '/dms/device/bizType/swapRule', // 设备更换删除

  billVerifyRecordPage: '/fms/tradeSeller/verify/bill/record/list', // [GET] 账单核销记录分页
  billVerifyRecordExport: '/fms/tradeSeller/verify/bill/record/export', // [GET] 账单核销记录导出

  billTradeStateDraft: '/fms/fmsChange/billTradeState/draft', // [POST] 账单交易状态变更-保存草稿
  billTradeStateInfo: '/fms/fmsChange/billTradeState/info', // [GET] 账单交易状态变更-详情 {changeId}
  billTradeStateLinkedBill: '/fms/billOrderTerm/change/billTradeState/linkedBill', // 账单交易状态变更-预览账单

  workReportPage: '/report/dms/workReport/page', // [GET] 报告记录分页
  workReportExport: '/report/dms/workReport/ppt/export', // [GET] 报告记录导出
  workReportExport2Oss: '/report/dms/workReport/ppt/export2Oss', // [GET] 报告记录导出到oss
  workReportPushEmail: '/report/dms/workReport/push/email', // [POST] 报告记录发送邮件
  workReportRetry: '/report/dms/workReport/retry', // [POST] 报告记录重试 {genRecordId}
  workReportSchedulePage: '/report/dms/workReport/schedule/page', // [GET] 推送计划分页
  workReportScheduleSave: '/report/dms/workReport/schedule/save', // [POST] 推送计划保存
  workReportScheduleDelete: '/report/dms/workReport/schedule/delete', // [POST] 推送计划删除
  userList4Org: '/base/user/list4Org', // [GET] 岗位下的用户列表

  locationSchedulePage: '/report/dms/location/schedule/page',
  locationScheduleAdd: '/report/dms/location/schedule/add',
  locationScheduleUpdate: '/report/dms/location/schedule/update',
  locationScheduleDelete: '/report/dms/location/schedule/delete',
  locationPlanExport: '/report/dms/location/schedule/export',
  // AI 对话相关接口
  AiChatStream: '/ai/chat/chat', // SSE 流式对话（后端 /chat/chat，参数走 query）
  AiChatSessions: '/ai/chat/list', // 对话列表（GET，按更新时间倒序，userId 取后端登录态）
  AiChatMessages: '/ai/chat/messages', // 指定对话的消息列表（GET，参数 sessionId，按创建时间正序）
  AiChatDeleteSession: '/ai/chat/session/delete', // 删除对话（POST，路径拼接 sessionId，同时删除该对话下所有消息）
  AiChatCreateSession: '/ai/chat/session', // 创建会话（后续扩展）
  AiChatFeedback: '/ai/chat/feedback', // 消息反馈（POST，参数 msgId、feedback：0-无反馈/1-点赞/2-点踩）
  AiMetaTablePage: '/ai/meta/table/page', // 分页查询数据表列表
  AiMetaIndexPage: '/ai/meta/index/page', // 分页查询表索引列表
  AiMetaColumnPage: '/ai/meta/column/page', // 分页查询表字段列表
  AiMetaColumnList: '/ai/meta/column/listByTable', // 表字段列表（GET，传参 dbCode + tableCode）
  AiMetaColumnAdd: '/ai/meta/column/add', // 新增表字段（POST）
  AiMetaColumnUpdate: '/ai/meta/column/update', // 编辑表字段（POST）
  AiMetaColumnDelete: '/ai/meta/column/delete', // 删除表字段（POST，调用时拼接 /{metaColumnId}）
  AiMetaTableAdd: '/ai/meta/table/add', // 新增数据表（POST）
  AiMetaTableUpdate: '/ai/meta/table/update', // 修改数据表（POST）
  AiMetaTableDelete: '/ai/meta/table/delete', // 删除数据表（POST，调用时拼接 /{metaTableId}）
  AiMetaTableDetail: '/ai/meta/table/detail', // 查询数据表详情（GET，调用时拼接 /{metaTableId}）
  AiMetaTableDictTable: '/ai/meta/table/dict/table', // 查询「数据表」下拉列表（GET）
  AiMetaTableDictDbCode: '/ai/meta/table/dict/dbCode', // 查询「数据库编码」下拉列表（GET，传参dbType）
  AiMetaColumnListByTable: '/ai/meta/column/listByTable', // 查询指定数据表的字段列表（GET，传参dbCode、tableCode，用于索引字段多选）
  AiMetaIndexAddBatch: '/ai/meta/index/addBatch', // 批量新增表索引（POST，参数dbCode、tableCode、indexList）
  AiMetaIndexUpdate: '/ai/meta/index/update', // 修改表索引（POST，单条）
  AiMetaIndexDelete: '/ai/meta/index/delete', // 删除表索引（POST，调用时拼接 /{metaIndexId}）
};
